import Locale from 'element-ui/lib/locale/lang/fr.js' // 引入element语言包
const fr = {
  login: {
    name: '',
    page: '',
    lanuage: 'Langue',
    text: "Se connecter avec l'email",
    text2: 'Se connecter avec le code de vérification',
    email: 'Compte e-mail',
    placeholdername: 'Compte e-mail',
    placeholderemail: 'Entrez le compte e-mail',
    emailformate: "Format d'adresse e-mail incorrect",
    placeholderpsw: 'Mot de passe',
    login: 'Connexion',
    account: 'Se souvenir de moi',
    password: 'Mémoriser le mot de passe',
    rememberPhone: 'Mémoriser le numéro de téléphone',
    getCode: 'Envoyer code',
    register: "s'inscrire",
    passwords: 'Mot de passe oublié',
    pswr: 'Veuillez saisir le mot de passe',
    emailr: 'Code de vérification du courrier',
    phone: 'Se connecter avec le numéro de téléphone',
    phoneplace: 'Numéro de téléphone portable',
    phoneerror: 'Format de numéro de téléphone portable incorrect',
    phoneverify: 'Code de vérification',
    countryTitle: 'Pays/Région',
    tokenError: "Délai d'attente de connexion expiré !",
    accountDisabled: 'Le compte est banni !',
    userNotActivated: "Le compte n'est pas activé !",
    userFrozen: 'Le compte a été bloqué !',
    tryAgain: 'Réessayez plus tard',
    validPhoneNumber: 'Veuillez saisir un numéro de téléphone valide.',
    simplifiedChinese: 'Chinois simplifié'
  },
  sync: {
    overflow: 'Débordement',
    manle: `Les scènes de cet appareil sont pleines et ne peuvent pas participer à la scène 【 $$】. Pour rejoindre une nouvelle scène, veuillez d'abord supprimer les scènes existantes, puis cliquer sur [Réessayer].`,
    data: 'Heure de début',
    areaname: 'Zone',
    time: 'Heure',
    identification: 'Identifier',
    retry: 'Réessayer',
    delete: 'Effacer',
    synchronizing: 'Synchronisation en cours...',
    cousreTitle: 'Synchronisation des données',
    background: 'Exécuter en arrière-plan',
    allTry: 'Réessayer tout',
    info: 'Info',
    alltry: 'Réessayer tout',
    close: 'Annuler',
    area: 'Zone',
    scene: 'Scénarios',
    ifttt: 'Automatisation',
    config: 'Configuration des paramètres',
    projectId: 'ID du projet:',
    constIllumination: 'Lumière du jour',
    rhythm: 'Calendrier'
  },
  sylogs: {
    dataControlTip: 'Seuls les données des trois derniers mois sont affichées',
    dataControlTip1: "Afficher uniquement les 50 entrées les plus récentes. Changer de date pour afficher les données d'un jour spécifique",
    infor: 'Information',
    warning: 'Avertissement',
    error: 'Erreur',
    to: 'à',
    startdate: 'Date de début',
    enddate: 'Données de fin',
    plhode2: 'Veuillez sélectionner le niveau',
    plhode3: 'Veuillez saisir le nom',
    plhode4: "Veuillez saisir l'ID de l'événement",
    plhode5: 'Veuillez saisir les détails',
    search: 'Recherche sur',
    out: 'Exporter',
    dates: 'Heure',
    lever: 'Niveau',
    id: "ID du nuage d'appareils",
    name: 'Nom du dispositif',
    EventID: "ID de l'événement",
    detail: 'Détails',
    waring: "Conflit d'adresse de l'appareil",
    all: 'Tout',
    downfiletip: 'Le fichier de téléchargement est en cours de génération, veuillez patienter.',
    systemModuleName: 'Modules associés',
    userActionTypeName: "Type d'opération",
    urlPath: "Chemin d'accès à l'interface",
    arguments: 'Paramètres de la demande',
    callResultCode: 'Retourner à',
    uCloudId: 'ID du nuage',
    ipAddress: "IP de l'opération",
    success: 'Réussi',
    fail: 'Échoué',
    datapickerLimit: "Le délai maximum pour l'exportation est de 1 mois, veuillez l'ajuster.",
    allEvent: 'Tous les événements'
  },
  failureLogs: {
    dates: 'Heure du rapport',
    id: "ID du nuage d'appareils",
    name: 'Nom du dispositif',
    area: 'Zone',
    failure: 'État de défaut',
    operation: 'Opération',
    failureRemind: 'Alarme de défaut',
    time: 'Heure',
    go: 'Vérifier les détails'
  },
  otaUpdate: {
    customTime: 'Programmation personnalisée',
    notStarting: 'Manuel',
    name: 'Nom du dispositif',
    type: "Type d'appareil",
    online: 'En ligne',
    Update: 'Mise à jour',
    caozuo: 'Opération',
    update: 'Mise à niveau OTA',
    know: 'Identifier',
    stop: 'Arrêter',
    tab1: 'Tout',
    tab2: 'Mise à jour requise',
    tab3: 'Mise à niveau en cours.',
    tab4: 'Mise à niveau réussie',
    tab5: 'Échec de la mise à niveau.',
    offline: 'Hors ligne',
    identification: 'Identifier',
    upgrade: 'Mise à niveau OTA',
    initiatefail: 'Échec du lancement de la mise à jour',
    ingfail: 'Échec de la mise à niveau.',
    success: 'Mise à niveau réussie',
    warninginfor: 'Aucun appareil pouvant être mis à niveau',
    waitForupgrade: 'En attente de mise à jour',
    Upgradeing: 'Mise à niveau en cours.',
    UpgradeSuccess: 'Réussi',
    UpgradeDuplicate: 'Échoué',
    UpgradeFail: 'Mise à jour en double',
    UpgradeConfilct: 'Conflit détecté !',
    UpgradeBusy: 'Occupé',
    UpgradeProjectIdNull: "Pas d'ID de projet",
    info: 'Info',
    stopfail: 'Échec de l\'arrêt',
    stopsuccess: 'Arrêt réussi',
    wakeUpDeviceAndUpgrade: "Réveillez l'appareil comme indiqué ci-dessous, puis cliquez sur « Mettre à niveau maintenant » pour terminer la mise à jour",
    webMeshOtaNotSupported: 'Le firmware Bluetooth actuel ne prend pas en charge Web Mesh OTA ; veuillez utiliser la mise à niveau App GATT',
    upgradeNow: 'Mettre à niveau maintenant',
    automaticUpgrade: 'Mise à niveau automatique'
  },
  addThirdDevice: {
    addgateway: 'Sélectionnez un boîtier de connexion intelligent',
    span: 'Ajouter un appareil tiers',
    step1: 'Sélectionnez un boîtier de connexion intelligent',
    step2: 'Sélectionner le protocole',
    step3: "Type d'appareil",
    save: 'Sauvegarder',
    back: 'Retourner à',
    productKey: 'Toutes les chaînes du code QR'
  },
  addVirtualGateway: {
    next: 'Suivant',
    previous: 'Retour',
    devicename: 'Nom du dispositif',
    writedevicename: 'Veuillez entrer le nom de votre appareil',
    span: 'Ajouter une Smart Connect Box',
    step1: '1. Sélectionner le type',
    step2: '2. Saisir les informations',
    header: 'Sélectionner le type',
    typewarning: 'Sélectionner le type',
    success: 'Réussi',
    error: 'Échec',
    confiminfor: "L'appareil faisait partie d'un autre projet, êtes-vous sûr de vouloir continuer ?",
    notice: 'Avis',
    sure: 'Confirmer',
    back: 'Retourner à',
    cancle: 'Annuler'
  },
  forgetpsw: {
    account: 'Compte e-mail',
    password: 'Mot de passe',
    surepassword: 'Confirmez votre mot de passe',
    emailr: 'Veuillez saisir votre code de vérification',
    yanzhneg: 'Code de vérification du courrier',
    placeholderemail: 'Entrez le compte e-mail',
    placeholderpsw: 'Veuillez saisir le mot de passe',
    placeholderpswagain: 'Veuillez saisir à nouveau votre mot de passe',
    name: "Projet d'éclairage intelligent",
    setnewpsw: 'Définir le mot de passe',
    setpsw: 'trouver le mot de passe',
    agree: 'Lire et accepter les conditions générales',
    ok: 'Effectué',
    moredpsw: 'Veuillez saisir le mot de passe de confirmation',
    passnosame: 'Le mot de passe ne correspond pas',
    pswr2: 'Veuillez utiliser 6-15 chiffres et lettres. (pas de caractères spéciaux)',
    emailformate: "Format d'e-mail incorrect",
    userLive: 'Utilisateur actif',
    userOff: 'L\'utilisateur n\'existe pas'
  },
  findGateway: {
    next: 'Suivant',
    previous: 'Retour',
    devicename: 'Nom du dispositif',
    suredevice: 'Confirmer',
    countdown: 'Compte à rebours',
    '120s': "Veuillez cliquer sur le bouton « Confirmer » de la Smart Connect Box comme indiqué sur l'image ci-dessus, puis cliquez sur « Suivant ».",
    g2Confirm: `Veuillez cliquer sur le bouton « Mesh » de la Smart Connect Box comme indiqué sur l'image ci-dessus, puis cliquez sur « Suivant ».`,
    mac: 'Adresse MAC',
    macplaceholder: "Veuillez saisir l'adresse MAC",
    scanning: 'Scanner le code QR',
    infor1: "Réinitialisez l'appareil et connectez-le à Internet",
    infor2: "Veuillez saisir l'adresse MAC",
    span: 'Ajouter une Smart Connect Box',
    step1: '1. Sélectionnez le type de Smart Connect Box',
    step2: '2. Suivez les instructions et réinitialisez la Smart Connect Box',
    step3: '3. Attribuez votre Smart Connect Box',
    step4: '4. Confirmer l\'appareil',
    step5: '5. Rechercher la Smart Connect Box',
    step6: "Vous pouvez toujours appuyer sur le bouton de la Smart Connect Box pour la coupler au réseau si vous l'avez simplement oubliée.",
    header: 'Sélectionnez le type de Smart Connect Box',
    typewarning: 'Sélectionnez le type de Smart Connect Box',
    macwarning: "Veuillez saisir l'adresse MAC",
    success: 'Recherche réussie',
    error: 'Recherche échouée',
    confiminfor: "L'appareil est actuellement utilisé dans un autre projet. Voulez-vous vraiment continuer ?",
    notice: 'Avis',
    sure: 'Confirmer',
    back: 'Retourner à',
    cancle: 'Annuler',
    macerror: 'Format incorrect. Veuillez vérifier à nouveau votre adresse MAC',
    textHeader: "Restaurer les paramètres d'usine et la configuration réseau",
    textOne: 'Réinitialisez la Smart Connect Box en appuyant sur le bouton de réinitialisation situé sur le côté.',
    textTwo: 'Réinitialisez la Smart Connect Box en appuyant sur le bouton de réinitialisation situé sur le côté.',
    textThree: "L'icône verte ON/OFF commencera à clignoter.",
    textfour: "Appuyez et maintenez enfoncé jusqu'à ce que les 3 icônes du haut aient clignoté une fois. Cela indique que la réinitialisation a réussi.",
    textfive: 'IP statique',
    textsix: "Procédez ensuite comme suit : revenez sur cette page après avoir terminé la configuration via la configuration d'une adresse IP statique.",
    textseven: "La Connect Box a besoin d'un accès Internet non bloqué (un pare-feu peut limiter cela), assurez-vous que les 3 voyants LED sont allumés. Veuillez toujours",
    texteight: 'WIFI',
    texteight1: 'Contacter le service informatique',
    textnine: 'nous informer si vous devez ajouter la Connect Box à la liste blanche.',
    textnine1: 'Si une adresse IP statique est requise, veuillez poursuivre la configuration',
    textnine2: 'IP statique',
    staticipsetcaption: "Procédure de configuration d'une adresse IP statique",
    staticipsetcaption1: 'Le service informatique local doit savoir :',
    staticipsetinfo: `La mention « IP statique » en bleu fait référence à la procédure standard (SOP), comme c'est le cas actuellement à cette étape./nContactez au préalable votre responsable informatique pour obtenir les informations relatives à l'adresse IP statique (adresse IP, masque de sous-réseau et passerelle par défaut) destinée à la Smart Connect Box./nActivez le mode Bootloader de la Smart Connect Box pour établir la communication<br>- Connectez la Smart Connect Box directement à votre ordinateur à l'aide d'un câble Ethernet ; <br> - Ouvrez le menu Démarrer ➔ Paramètres du PC ➔ Réseau et Internet ➔ Ethernet ➔ Modifier les options de l'adaptateur ➔ Choisissez le port Ethernet concerné ➔ Double-cliquez pour accéder à la page Propriétés Ethernet ➔ Double-cliquez sur Protocole Internet version 4 (TCP/IPv4) ➔ Général ➔ Utilisez l'adresse IP suivante <br> - Configurez l'adresse IP de votre ordinateur sur 192.168.1.X (X pouvant être compris entre 2 et 254), le masque de sous-réseau sur 255.255.255.0 ; l'adresse IP de la passerelle par défaut doit être 192.168.1.1, appuyez sur OK pour enregistrer les modifications. <br>- Appuyez sur la touche de fonction de la Smart Connect Box (le bouton carré) et maintenez-la enfoncée pendant 15 secondes jusqu'à ce que le voyant d'alimentation vert clignote. Cela indique que la Smart Connect Box est activée avec le programme de démarrage. <br>/nOuvrez votre navigateur Web et saisissez 192.168.1.1 pour accéder à la page Web de la Smart Connect Box ;/nDans la configuration Ethernet ➔ Modifiez le paramètre IP de DHCP à IP statique ➔ Saisissez l'adresse IP, le masque de sous-réseau et la passerelle requis (fournis par le responsable informatique) ➔ Cliquez sur Enregistrer pour enregistrer les modifications ;/nAppuyez à nouveau sur la touche de fonction pour redémarrer la Smart Connect Box. La Smart Connect Box utilisera désormais l'adresse IP statique qui a été définie.`,
    staticipsetinfo5: `Le terme « IP statique » en bleu fait référence à la procédure standard (SOP), comme à l'étape actuelle./nContactez à l'avance votre responsable informatique pour obtenir les informations d'IP statique (adresse IP, masque de sous-réseau et passerelle par défaut) destinées à la Smart Connect Box G2./nConnectez le port LAN du routeur directement à la Smart Connect Box à l'aide d'un câble Ethernet./nAccédez à la page d'administration du routeur (contactez votre administrateur informatique pour les informations d'accès) et localisez l'adresse IP de la Smart Connect Box correspondante à l'aide de son adresse MAC./nOuvrez un navigateur et saisissez https://[IP de la passerelle] pour vous connecter au système Web d'éclairage intelligent. Lors de la première connexion, vous devrez définir un mot de passe. (Si vous oubliez votre mot de passe, vous pouvez le réinitialiser à l'aide des informations du projet, notamment le code du projet, l'ID cloud de l'appareil et l'adresse MAC. Vous pouvez également restaurer la Smart Connect Box G2 aux paramètres d'usine via une réinitialisation matérielle.)/nDans la configuration Ethernet ➔ passez le paramètre IP de DHCP à IP statique ➔ saisissez l'adresse IP, le masque de sous-réseau et la passerelle requis (fournis par le responsable informatique) ➔ cliquez sur « Enregistrer » ;/nAppuyez brièvement sur le bouton Reset avec une épingle pour redémarrer la Smart Connect Box G2. La Smart Connect Box utilisera désormais l'adresse IP statique configurée.`,
    staticipsetinfo6: `En cas d'utilisation d'un pare-feu ou d'un système de sécurité, fournissez l'adresse MAC de chaque Smart Connect Box G2 à votre équipe informatique locale. Celle-ci ajoutera ces adresses MAC à la liste blanche, ce qui évite aussi des problèmes de connexion futurs./nPour assurer le fonctionnement stable de la Smart Connect Box, ouvrez les ports TCP 80, 443 (HTTPS) et 8883 (MQTT). Le port 80 est nécessaire pour la récupération des journaux. Assurez-vous également que le domaine iotctrl1.opple.com est accessible ; il s'agit du serveur cloud utilisé par la Smart Connect Box G2.`,
    staticipsetinfo1: `En cas de pare-feu ou de système de sécurité, fournissez la ou les adresses MAC de la ou des Smart Connect Box à l'équipe informatique locale./nL'équipe informatique locale ajoutera les adresses MAC à la liste blanche, ce qui évite aussi des problèmes de connexion futurs./nSi la version du firmware de la Connect Box est inférieure à V87.xx.xx, ouvrez TCP : 80, 443 et UDP : 65501 pour la mise à niveau. Après la mise à niveau vers V87.xx.xx, le protocole passera automatiquement à TCP : 443 (HTTPS), 8883 (MQTT). Après la mise à niveau, vous pouvez fermer TCP : 80 et UDP : 65501. Le port 80 doit rester activé pour la récupération des journaux de la Smart Connect Box./nAssurez-vous également que le nom de domaine iotctrl1.opple.com est autorisé ; il s'agit du serveur/cloud avec lequel les Connect Box communiquent.`,
    finishedDeviceCheck: 'Cochez la case si vous confirmez',
    notAllowGateway: "L'ajout de cette passerelle n'est actuellement pas pris en charge",
    addOnApp: "Veuillez ajouter la configuration dans l'application",
    deviceInfoError: "L'appareil présente un dysfonctionnement. Veuillez contacter l'installateur ou le service client OPPLE pour organiser un retour ou un remplacement.",
    g2Tip1: "Description des voyants : ① voyant d'état, ② voyant Ethernet, ③ voyant Internet, ④ voyant Wi-Fi.",
    g2Tip2: "Si le voyant Ethernet n'est pas allumé, vérifiez que le câble réseau est correctement branché au routeur,",
    g2Tip3: 'veuillez contacter le service informatique',
    g2Tip4: `Si le voyant Internet n'est pas allumé, vérifiez que le routeur a un accès Internet normal et que les voyants Ethernet ou Wi-Fi fonctionnent correctement.`,
    g2Tip5: 'Si vous devez obtenir une adresse IP dans le réseau local,',
    g2Tip9: "Attendez que les voyants d'état, Ethernet et Internet soient allumés, puis cliquez sur Suivant.",
    g2Tip10: `Maintenez le bouton de réinitialisation illustré enfoncé pendant au moins 10 secondes ; un clignotement rapide indique une réinitialisation réussie.`,
    g2Tip11: 'adresse IP statique',
    g2Tip12: 'pour accéder correctement au réseau,'
  },
  findDevice: {
    addgateway: 'Sélectionnez un boîtier de connexion intelligent',
    span: 'Découvrir les appareils',
    step1: 'Sélectionnez un boîtier de connexion intelligent',
    step2: 'Sélectionnez un type de connexion',
    step3: 'Scanner',
    step4: 'Arrêter le scan',
    child: 'Connexion',
    progress: 'Progression :',
    save: 'Sauvegarder',
    back: 'Retourner à',
    warning: 'Sélectionnez un type de connexion',
    finddevicetotal: "Nombre total d'appareils scannés",
    countdown: 'Compte à rebours de scan :',
    area: 'Quartier :',
    areaNo: 'Indicatif régional',
    areaNoPlaceholder: "Veuillez saisir l'indicatif régional",
    group: 'Groupe :',
    groupNo: 'Numéro de groupe',
    gateway: 'Passerelle GrantsBay',
    findDevice: "Détecter l'appareil",
    moveAllDevice: "Par défaut, tous les appareils sont déplacés dans la pièce, qu'ils y soient déjà ou non ?",
    moveAllDeviceTip: 'Si vous ne les déplacez pas, vous pourrez le faire ultérieurement dans la zone « Aucune ».',
    notMoveIn: 'Pas encore emménagé',
    moveIn: 'Emménager',
    gatewayName: 'Saisissez le nom de la passerelle',
    selectDevice: "Veuillez sélectionner l'appareil",
    selectAll: 'Sélectionner tout',
    remove: 'Supprimer'
  },
  register: {
    account: 'Compte e-mail',
    password: 'Mot de passe',
    surepassword: 'Confirmez à nouveau votre mot de passe',
    name: "Projet d'éclairage intelligent",
    placeholderemail: 'Entrez le compte e-mail',
    emailformate: "Format d'e-mail incorrect",
    psw: 'Enregistrer',
    regis: "s'inscrire",
    info: "(En tant qu'installateur)",
    address: 'Adresse',
    phone: 'Numéro de téléphone',
    yanzhneg: 'Code de vérification du courrier',
    finsh: 'Effectué',
    agreen: 'Lire et accepter les conditions générales',
    placeholderpsw: 'Veuillez saisir le mot de passe',
    moredpsw: 'Veuillez saisir à nouveau votre mot de passe',
    emailr: 'Veuillez saisir votre code de vérification',
    pswr2: 'Veuillez utiliser 6-15 chiffres et lettres. (pas de caractères spéciaux)',
    phoneerror: 'Erreur de téléphone',
    passnosame: 'Le mot de passe est incohérent',
    checkmessage: 'Lisez et acceptez les conditions générales',
    privacy: 'Politique de confidentialité',
    declaration: "(1) Pour pouvoir utiliser le système de commande d'éclairage intelligent Opple, l'utilisateur doit utiliser une adresse e-mail professionnelle plutôt qu'une adresse e-mail personnelle.<br>(2) Opple recueillera uniquement l'adresse e-mail professionnelle de l'utilisateur, ses préférences système et des informations sur les produits.<br>Opple ne conserve aucune information personnelle concernant l'utilisateur. <br>(3) Les informations stockées par Opple servent uniquement à garantir le bon fonctionnement du système de contrôle d'éclairage intelligent Opple.<br> (4) À tout moment, à la demande du client, les informations stockées par Opple peuvent être entièrement supprimées. <br>(5) Pour utiliser le système de contrôle d'éclairage intelligent Opple, l'utilisateur doit accepter les présentes conditions.<br> II. Si l'utilisateur supprime son compte via la fonction « Supprimer l'utilisateur », le système supprimera<br>toutes les informations liées à ce compte.<br>Pour le point (4), voir II en complément",
    existingAccount: 'Vous avez déjà un compte ?',
    countryempty: 'Pays/Région (vide)'
  },
  header: {
    transProject: 'Transférer le projet',
    exit: 'Se déconnecter',
    projectname: 'Nom du projet :',
    editmsg: 'Modifier',
    restpsw: 'Réinitialiser le mot de passe',
    loginOut: 'Déconnexion',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    language: 'Anglais',
    oldpassword: 'Ancien mot de passe',
    newpassword: 'Nouveau mot de passe',
    confirmpassword: 'Confirmez le nouveau mot de passe',
    username: 'Nom',
    useraddress: 'Adresse',
    userphone: 'Téléphone',
    oldpasswarn: "Entrez à nouveau l'ancien mot de passe",
    newpasswarn: 'Entrez à nouveau le nouveau mot de passe',
    twopasswarn: 'Veuillez vous assurer que les deux mots de passe correspondent',
    dosending: 'Échange Projet',
    switchProject: 'Échange Projet',
    logOutUser: 'Se désinscrire',
    cancelUserTitle: 'Supprimer le compte',
    cancelUserOneTips: "Il n'y a qu'un seul installateur pour le ou les projets ci-dessus. Le projet ne pourra pas être récupéré après sa suppression.",
    cancelUserMoreTips: "Pour la sécurité de votre compte, vous ne pouvez vous désinscrire que si votre compte ne contient aucun projet. Veuillez supprimer les projets ou les transférer à d'autres personnes avant de vous désinscrire.",
    cancelUserOneDelTips: "Il n'y a qu'un seul installateur pour ce projet. Le projet ne pourra pas être récupéré après sa suppression. Êtes-vous sûr de vouloir continuer ?",
    cancelUserMoreDelTips: 'Après vous être désinscrit de ce projet, vous ne pourrez plus y accéder. Êtes-vous sûr de vouloir continuer ?',
    cancelUserOperOneMoreTips: 'Les projets qui contiennent encore des appareils ne peuvent pas être supprimés, mais uniquement transférés.',
    selected: 'Sélectionné',
    project: 'Élément',
    recipientEmail: 'Adresse e-mail',
    recipientEmailConfirm: "Confirmer l'adresse e-mail",
    cancelUser: 'Veuillez confirmer la suppression du compte. Une fois supprimé, vous ne pourrez plus vous connecter.',
    bindPhoneTitle: "Confirmation de l'association",
    unbindPhoneTitle: 'Confirmation de la désassociation',
    bindPhoneTips: "Une fois l'association effectuée, vous pouvez utiliser la connexion par téléphone portable",
    unbindPhoneTips: 'Une fois la désassociation effectuée, vous ne pourrez plus utiliser votre téléphone portable pour vous connecter au compte',
    noBindPhoneTips: 'Pas de téléphone portable',
    noBindEmailTips: "Pas d'adresse e-mail",
    bindPhoneOpareTips: "La connexion par téléphone portable n'est pas prise en charge sur le Web",
    transferEmail: 'Par courriel',
    recipientPhone: 'Numéro de téléphone',
    recipientPhoneConfirm: 'Confirmer le numéro de téléphone',
    setpsw: 'Définir le mot de passe',
    bindEmailTips: "Une fois l'association terminée, vous pouvez utiliser cette adresse e-mail pour vous connecter à votre compte",
    unbindEmailTips: 'Après la désassociation, vous ne pourrez plus utiliser cette adresse e-mail pour vous connecter à votre compte.',
    transferPhone: 'Par téléphone',
    helpTip: 'Bonjour, comment puis-je vous aider ?',
    helpDocument: "Document d'aide",
    commonProblem: 'FAQ',
    userGuide: "Guide de l'utilisateur",
    problemType: 'Catégories de problèmes',
    submitter: 'Auteur',
    submitTime: "Heure d'envoi",
    emailFormatMismatch: "Format d'adresse e-mail incorrect",
    phoneNumberMismatch: 'Numéros de téléphone incorrects'
  },
  sidebar: {
    home: 'Startseite',
    details: 'Détails du projet',
    projectDetails: 'Détails du projet',
    management: 'Utilisateur',
    install: 'Installation d\'appareils',
    monitoring: 'Surveillance',
    control: 'Contrôle de l\'éclairage',
    automation: 'Automatisation',
    systemLog: 'Journal système',
    failureList: 'Alertes sur les appareils',
    ota: 'Mise à niveau',
    screen: 'Écran',
    otatask: 'Tâche de mise à jour',
    notices: 'Notifications'
  },
  devicelist: {
    treeplaceholder: 'Recherche',
    warnmove: 'Même zone, veuillez choisir une autre zone vers laquelle vous déplacer.'
  },
  projectList: {
    liteProjectTip: 'Sans Connect Box System Lite',
    projectNum: "Projet d'éclairage intelligent",
    add: 'Ajouter',
    projectApp: "Système d'éclairage intelligent classique",
    openApp: "Veuillez utiliser l'application Opple Smart Lighting pour ouvrir le projet",
    name: 'Nom du projet :',
    time: "Définir l'heure",
    people: 'Propriétaire',
    state: 'Statut du projet',
    num: "Quantité d'appareils",
    address: 'Emplacement',
    UserRole: 'Rôle',
    UserRole1: 'Propriétaire',
    UserRole2: 'Propriétaire',
    UserRole3: 'Administrateur',
    UserRole4: 'Utilisateur',
    UserRole5: 'Visiteur',
    caozuo: 'Opération',
    in: 'Ouvrir',
    all: 'Archives',
    modify: 'Modifier',
    accept: 'Accepter',
    refuse: 'Refuser',
    allcountry: 'Tout',
    normal: 'Normal',
    malfunction: 'Défaut',
    activate: 'Activer',
    delete: 'Effacer',
    good: 'Bien',
    serachWord: 'Nom du projet',
    fireProject: "Projets de lutte contre l'incendie",
    comProject: 'Projet commercial',
    standardProject: 'Projet standard',
    collection: 'Collecter',
    unCollection: 'Déjà enregistré',
    continueConfiguring: 'Continuer la configuration',
    notOperable: 'Non opérationnel dans la configuration de projet standard'
  },
  projectmsg: {
    storeCode: 'Code du magasin',
    StoreName: 'Nom du magasin',
    isNo: 'N° IS du projet :',
    placeholder: 'Veuillez saisir le',
    fillChannel: 'Veuillez remplir complètement les données du canal',
    channel: 'Canal',
    projectInfo: 'Données du projet :',
    span1: 'Informations de base',
    span2: 'Détails du projet',
    name: 'Nom du projet',
    type: 'Type de projet :',
    country: 'Pays :',
    time: 'le fuseau horaire：',
    address: 'adresse du projet：',
    img: 'Image du projet：',
    code: 'Code postal：',
    plhode0: 'Veuillez saisir le nom du projet',
    plhode1: "Veuillez sélectionner le type de projet",
    plhode2: 'Sélectionnez le pays/la région',
    plhode3: 'Sélectionnez le fuseau horaire du projet',
    plhode4: "Veuillez saisir l'adresse du projet",
    plhode5: 'Veuillez saisir le code postal',
    plhode6: 'Veuillez sélectionner les attributs du projet',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    verificationName: 'Veuillez indiquer le nom de votre projet',
    verificationCountry: 'Veuillez sélectionner votre pays',
    verificationType: "Veuillez sélectionner le type de projet",
    verificationAttibute: 'Veuillez sélectionner les attributs du projet',
    verificationTimeZone: 'Veuillez sélectionner votre fuseau horaire',
    verificationWorkTime: 'Veuillez définir vos heures de travail.',
    imginfo: "La taille de l'image dépasse 2 Mo !",
    formateerror: "Format d'image incorrect, veuillez utiliser uniquement des fichiers JPEG ou PNG",
    bigerror: "La taille de l'image dépasse 2 Mo !",
    attribute: 'Type de projet :',
    ledEnergy: "Économie d'énergie LED :",
    ledEnergyTip: "Veuillez indiquer le pourcentage d'économie d'énergie LED",
    everyWorkTime: 'Heures de fonctionnement :',
    workStartTime: 'Début',
    workEndTime: 'Fin',
    span3: 'Informations du pays',
    span4: 'Info zone',
    DST: "Heure d'été：",
    DSTTime: 'Heure d\'été：',
    DSTTimeTips: "Veuillez sélectionner votre heure d'été",
    DSTTimeShift: 'Décalage horaire d\'été：',
    DSTTimeShiftTips: "Veuillez sélectionner votre décalage horaire d'été",
    DSTEnable: 'Activer',
    DSTDisable: 'Désactiver',
    to: '-',
    startdate: 'Date de début',
    enddate: 'Données de fin',
    month: 'Mois',
    day: 'Jour',
    countryModifyTips: "Si vous modifiez les informations relatives à l'heure d'été du projet, celles-ci seront synchronisées avec l'appareil. Êtes-vous sûr de vouloir les modifier ?",
    timeModifyTips: "Si vous modifiez les informations relatives au fuseau horaire du projet, celles-ci seront synchronisées avec l'appareil. Êtes-vous sûr de vouloir les modifier ?",
    modbusDocument: 'Fichier Modbus :',
    Meterdata: 'Données du compteur électrique :',
    ledEnergyError: "L'économie d'énergie LED ne peut pas dépasser 100 %",
    projectData: 'Données du projet :',
    exportIn: 'Importer des données :',
    exportOut: 'Exporter des données :',
    uploadFile: 'Téléchargement de fichiers',
    downloadFile: 'Télécharger le fichier',
    fireProject: "Lutte contre l'incendie",
    bacnetDocument: 'Fichier BACnet :',
    programList: 'Liste des programmes :',
    errorFileTip: 'Format incorrect, veuillez réimporter le fichier',
    dataImfo: 'Message de données',
    configured: 'Configuré',
    unconfigured: 'Non configuré',
    holidaysConfiguration: 'Configuration des jours fériés',
    effectiveImmediately: 'Appliquer maintenant',
    configurationNote: 'Instructions relatives aux jours fériés',
    holidaysConfigurationTip1: 'Définir les jours fériés : cliquez sur une date vide ;',
    holidaysConfigurationTip2: 'Après avoir cliqué sur « Appliquer maintenant », tous les paramètres de jours fériés dans toutes les automatisations (y compris les automatisations existantes) seront mis à jour !',
    holidaysConfigurationTip3: 'Annuler les jours fériés : cliquez sur une date déjà définie comme jour férié ;',
    springFestival: 'Fête du printemps',
    tombSweepingDay: 'Fête des morts',
    laborDay: 'Fête du Travail',
    dragonBoatFestival: 'Fête des bateaux-dragons',
    midAutumnFestival: 'Fête de la mi-automne',
    nationalDay: 'Fête nationale',
    newYearsDay: "Jour de l'An",
    weekEnds: 'Week-ends',
    pleaseClickToConfigure: 'Veuillez cliquer pour configurer',
    anyPointInTime: 'À tout moment',
    JSONOnly: 'Seuls les fichiers au format JSON peuvent être téléchargés !',
    fileNotExist: "Le fichier n'existe pas",
    fileReadFailed: 'Échec de la lecture du fichier',
    jsonFormatError: 'Erreur de format JSON, veuillez vérifier le contenu du fichier',
    uploadValidJson: 'Veuillez téléverser un fichier JSON valide',
    resetStandardHolidays: 'Réinitialiser aux jours fériés nationaux standard',
    clearAll: 'Tout effacer',
    confirmResetHoliday: 'Après la réinitialisation, les jours fériés personnalisés seront effacés. Continuer ?',
    confirmClearAll: "Après l'effacement, tous les jours fériés existants seront effacés. Continuer ?",
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
    standardHoliday: 'Jours fériés nationaux standard',
    customizeHoliday: 'Jours fériés personnalisés',
    useStandardHolidayNextYear: "Reporter les jours fériés nationaux standard à l'année prochaine",
    holidayUpdateSubscription: "S'abonner aux notifications de mise à jour des jours fériés",
    enterEmailAddress: "Veuillez saisir votre adresse e-mail",
    invalidEmailFormat: "Format d'adresse e-mail non valide",
    fetchError: "Nous ne parvenons pas à récupérer les informations relatives aux jours fériés. Veuillez contacter le chef de projet/l'installateur.",
    isAcknowledged: "D'accord.",
    countryChangeHoliday: "Nous vous rappelons que les informations sur le pays ayant été mises à jour, il serait utile de vérifier et d'enregistrer la configuration des jours fériés dans le projet. Merci.",
    pleaseSelectAtLeastOneHoliday: 'Veuillez sélectionner au moins un jour férié.',
    updatingTheCountry: 'Lors de la mise à jour du pays, souhaitez-vous mettre à jour automatiquement le fuseau horaire ?',
    electricityPriceSettings: "Paramètres du prix de l'électricité",
    pleaseSelectType: 'Veuillez sélectionner un type',
    peakHours: 'Heures de pointe',
    offPeakHours: 'Heures creuses',
    normalHours: 'Heures normales',
    others: 'Autres',
    electricityPrice: "Prix de l'électricité",
    yuanPerKwh: 'CNY/kWh',
    pleaseCompleteTimePeriodInfo: 'Veuillez renseigner toutes les informations de période',
    startTimeFormatInvalid: "L'heure de début doit être au format hh:mm et ne peut pas être 24:00",
    endTimeFormatInvalid: "L'heure de fin doit être au format hh:mm",
    startEndTimeCannotBeSame: "L'heure de début et de fin ne peuvent pas être identiques",
    invalidTimeFormat: "Format d'heure invalide ; veuillez utiliser hh:mm",
    invalidTimePeriod: "Période invalide ; veuillez resélectionner l'heure",
    timePeriodOverlap: 'Les périodes se chevauchent ; veuillez ajuster les heures',
    totalDurationExceeded: 'La durée totale est de 24 heures',
    pleaseConfigureTieredPricing: 'Veuillez configurer la tarification électrique par paliers',
    ratedPower: 'Puissance nominale (W)',
    powerDataConfiguration: 'Configuration des données de puissance',
    constantLightIntensity: 'Éclairement constant',
    pleaseSetLatitudeLongitude: "Veuillez d'abord définir la latitude et la longitude dans les détails du projet",
    playlistInformation: 'Informations sur la liste de lecture'
  },
  breadcrumb: {
    sy: 'Système',
    home: 'Startseite',
    Project: 'Liste des projets',
    Archive: 'Liste des projets archivés',
    projectMsg: 'Info projet',
    mangeUsers: 'Gérer les utilisateurs',
    addpeople: 'Ajouter un utilisateur',
    systemlog: 'Geräte',
    failureList: 'Alertes sur les appareils',
    otaup: 'Mise à niveau via OTA',
    deviceinstall: 'Installation',
    scence: 'Scénarios',
    device: 'Dispositif',
    install: 'Installation d\'appareils',
    districtmange: 'Zone',
    devicemange: ' Appareil',
    country: 'Sélectionner :',
    adddevice: 'Ajouter un appareil',
    addtruegateway: 'Ajouter une Smart Connect Box',
    addvirtualdevice: 'Ajouter un appareil virtuel',
    findDevice: 'Découvrir les appareils',
    control: 'Contrôle',
    monitoring: 'Surveillance',
    ifttt: 'Automatisation',
    iftttCustomSet: 'Sur mesure',
    templates: 'Modèle',
    scenceMsg: 'Scène',
    operatelog: 'Commande',
    otaTask: 'Upgrade',
    duplicateArea: 'Dupliquer la zone',
    iftttCustomSetPanel: "Interrupteur intelligent d'automatisation",
    mangeQrcode: "Partager l'espace",
    addShare: 'Ajouter Partager',
    mangeLimit: 'Utilisateur'
  },
  user: {
    placeholdUserName: 'Veuillez saisir le nom',
    type1: 'Installateur/Propriétaire',
    type2: 'Responsable',
    type3: 'Utilisateur',
    name: "Nom d'utilisateur",
    phone: 'Téléphone',
    address: 'Unit',
    state: "État",
    caozuo: 'Opération',
    add: 'Ajouter',
    sendemail: 'Renvoyer',
    limits: 'Rôle',
    del: 'Effacer',
    info: 'Avis',
    deltext: 'Êtes-vous sûr de vouloir supprimer ?',
    cancel: 'Annuler',
    yes: 'Oui',
    status: {
      0: 'Inviter',
      1: 'Normal',
      2: 'Refusé',
      3: 'Suppression en cours...'
    },
    refuse: "Vous avez refusé l'invitation",
    addOne: 'Invitation n°',
    editInfo: 'Modifier les détails du compte'
  },
  invite: {
    phoneInvite: 'Inviter par téléphone',
    emailInvite: 'Inviter par e-mail',
    phonerequired: 'Veuillez saisir le numéro de téléphone de la personne invitée',
    phoneerror: 'Veuillez utiliser le format correct',
    enterEmailCN: "Veuillez saisir l'adresse e-mail ou le numéro de téléphone de la personne invitée",
    inputPassword: 'Saisir le mot de passe',
    passwordAgain: 'Confirmer le mot de passe',
    inviteOrCreate: 'Inviter/Créer',
    createNewUser: 'Créer un nouveau compte',
    inviteSuccess: 'Invitation envoyée avec succès !',
    createSuccess: 'Création réussie !',
    loginNow: 'La personne invitée peut se connecter directement avec ce compte !',
    span: 'Informations de base',
    yaoqing: 'Inviter',
    plhode1: "Veuillez saisir l'adresse e-mail",
    plhode2: 'Veuillez saisir le numéro de téléphone',
    password: 'Veuillez saisir le mot de passe',
    span1: 'Envoyé avec succès.',
    span2: 'Veuillez rappeler à la personne invitée de vérifier !',
    span3: 'Retourner à',
    enterEmail: "Veuillez saisir l'adresse e-mail",
    enterLimite: 'Définir le rôle',
    limiteBlock: 'Autorisations par zone',
    finsh: 'Effectué',
    emailerror: 'Veuillez saisir une adresse e-mail valide',
    emailrequired: 'Veuillez saisir une adresse e-mail ou un numéro de téléphone',
    passwordMismatch: 'Les mots de passe ne correspondent pas'
  },
  monitor: {
    clickUpdate: 'Cliquez pour télécharger',
    dapingSetting: 'Paramètres',
    nameSetting: 'Paramètres du nom',
    backgroundSetting: 'Paramètres généraux',
    serverInfo: 'Informations sur le serveur',
    haveUsed: "En cours d'utilisation",
    free: 'En veille',
    cpuDetail: 'Informations sur le processeur',
    memoryDetail: 'Informations sur la mémoire',
    diskDetail: 'Informations sur le disque',
    cpuUsedInfo: 'Utilisation du processeur en temps réel',
    memoryUsedInfo: 'Utilisation de la mémoire en temps réel',
    showArea: "Zone d'affichage",
    showTime: 'Chronologie',
    DefaultAreaRank: 'Classement par défaut',
    customSettingRank: 'Classement personnalisé par niveau',
    rankingTitle1: 'Classement par zone au niveau 1',
    rankingTitle2: 'Classement par zone au niveau 2',
    rankingTitle3: 'Classement par zone au niveau 3',
    rankingTitle4: 'Classement par zone de niveau 4',
    saveEnergyRank: "Classement en matière d'économies d'énergie",
    useEnergyRank: "Classement en matière de consommation d'énergie",
    showMore: 'Afficher plus',
    curentDay: "Aujourd'hui",
    curentWeek: 'Cette semaine',
    curentMonth: 'Ce mois-ci',
    curentYear: 'Cette année',
    curentSeason: 'Ce trimestre',
    comfort: 'Confort',
    offline: 'Hors ligne',
    online: 'En ligne',
    open: 'Lumière ON',
    close: 'Lumière OFF',
    error: 'Défaut',
    allcount: 'Total',
    lampcount: 'Nombre total de lumières',
    canup: 'Mise à niveau',
    select: 'Choisir un appareil',
    allpower: 'Consommation totale du projet',
    allcomfort: 'Confort environnemental',
    importup: 'Exporter',
    realtimepowerconsumption: "Consommation d'énergie",
    comparisonofregions: "Comparaison de la consommation d'énergie par zone",
    selectarea: 'Choisissez Zone',
    agriAreaSelect: 'Zone',
    agriSensorTitle: 'Capteurs de lumière',
    agriSensorNatural: 'Capteur lumière naturelle',
    agriSensorUnderLamp: 'Capteur sous lampe',
    agriNoDataPlease: 'Aucune donnée, veuillez',
    agriPositionOutside: 'Extérieur',
    agriPositionRoof: 'Toit',
    agriPositionUnderLamp: 'Sous lampe',
    agriBindSensor: 'Lier capteur',
    agriRebindSensor: 'Modifier liaison',
    agriUnbindSensor: 'Délier capteur',
    agriLightStatistics: 'Statistiques lumière',
    agriLampBrightness: 'Luminosité lampe',
    agriTodayNaturalLight: 'Total lumière naturelle du jour',
    agriTodayArtificialLight: 'Total lumière artificielle du jour',
    agriSupplementDuration: 'Durée',
    agriTargetProgress: 'Progression cible',
    agriDliTotal: 'DLI total',
    agriDliNatural: 'Lumière naturelle',
    agriDliArtificial: 'Lumière artificielle',
    agriSensorNaturalValueLabel: 'Valeur lumineuse actuelle',
    agriSensorUnderLampValueLabel: 'PAR instantané',
    agriToday: "Aujourd'hui",
    agriYesterday: 'Hier',
    agriLastThreeDays: '3 derniers jours',
    agriLastMonth: 'Mois dernier',
    agriLastThreeMonths: '3 derniers mois',
    agriChartNaturalDLI: 'Lumière naturelle cumulée',
    agriChartArtificialDLI: 'Lumière artificielle cumulée',
    agriChartTotalDLI: 'Total lumière',
    agriExportLightRecords: "Enregistrements de fonctionnement des lampes",
    agriExportSensorReport: "Données des capteurs agricoles liés à la zone",
    agriExportSelectArea: "Veuillez d'abord sélectionner une zone",
    agriExporting: 'Export en cours, veuillez patienter…',
    hotspacepic: "Utilisation de l'espace",
    ranking: "Classement de l'utilisation de l'espace",
    utilizationrate: "Pourcentage d'occupation = Temps de détection de mouvement / Temps total",
    devicestatus: "État de l'appareil",
    sure: 'Confirmer',
    cancle: 'Annuler',
    selectdevicearea: 'Sélectionner',
    lasthour: 'Dernières 24 heures',
    lastweek: 'Dernière semaine',
    lastmonth: 'Dernier mois',
    lastyear: 'L\'année passée',
    realtime: 'Temps réel',
    onehour: 'Heure',
    warning1: 'Veuillez sélectionner au moins une zone',
    warning2: 'Veuillez sélectionner moins de 5 zones',
    warning3: "Veuillez sélectionner l'état de l'appareil",
    warning4: "Vous pouvez sélectionner jusqu'à 10 zones",
    warning5: 'Vous devez sélectionner au moins deux zones',
    areapowerline: "Consommation d'énergie",
    time: '',
    spacehottotal: "Utilisation de l'espace",
    haveperson: 'Présence',
    noperson: 'Absence',
    areazline: "Histogramme de consommation par zone",
    powername: "Consommation d'énergie",
    nodata: 'Aucune donnée valide pour le moment',
    nh: "Consommation d'énergie",
    hotvalue: 'Taux d\'utilisation',
    occupancyActiveButton: "Afficher l'analyse d'occupation",
    faultDevice: 'Appareil présentant un ou plusieurs défauts',
    systemState: 'État du système',
    systemNormal: 'Normal',
    systemDeploy: 'Réglage',
    systemUnusual: 'Défaut',
    systemDeployTips: "L'appareil n'a pas terminé la synchronisation.",
    systemUnusualTips: 'Une erreur système, telle que des appareils défectueux, est présente',
    choose: 'Sélectionner',
    realityEnergy: 'Consommation réelle',
    realityEnergy1: 'Total réel',
    todayEnergy: "Aujourd'hui",
    designEnergy: 'Prévu',
    savingEnergy: "Économie d'énergie",
    maxEnergy: 'Consommation max.',
    minEnergy: 'Consommation min.',
    avgEnergy: 'Moyenne',
    ledEnergy: 'Économie LED',
    smartEnergy: 'Économie intelligente',
    ledEnergyRate: "Taux d'économie LED",
    smartEnergyRate: "Taux d'économie intelligente",
    totalData: 'Tableau de bord',
    changeEnergy: 'Modifier',
    designEnergyTips: "Énergie nominale = ∑ⁿ (temps d'allumage × puissance maximale de l'éclairage).",
    smartEnergyTips: "Taux d'économie intelligente = (énergie réelle - énergie nominale) / énergie nominale.",
    ledEnergyTips: "Taux d'économie LED = (puissance totale de l'éclairage d'origine - puissance totale du nouvel éclairage) / puissance totale de l'éclairage d'origine.",
    sArea: 'Déplacer la zone',
    sConfig: "Configuration de l'appareil",
    sConstillumination: "Configuration de la lumière du jour",
    sIFttt: 'Configuration d\'automatisation',
    sProject: 'ID du projet:',
    sRhythm: 'Contrôle par programmation',
    sScene: 'Contrôle par scénario',
    systemTitle: "Système d'éclairage intelligent Opple",
    projectname: 'Nom du projet :',
    projTodayTotalEnergy: "Consommation totale d'énergie du projet pour aujourd'hui",
    dateButtonTxt: 'Veuillez sélectionner une période de 2 à 48 heures',
    dateButtonTxt1: 'Veuillez sélectionner une période de 2 à 90 jours',
    dateButtonTxt2: 'Veuillez sélectionner une période de 2 à 60 mois',
    dateButtonTxt3: 'Veuillez sélectionner une période de 2 à 30 ans',
    areaname: 'Zone',
    areaChoose: 'Choisissez 2 à 10 zones à comparer',
    areaContrast: "Comparaison de la consommation d'énergie par zone",
    hour: 'Heures',
    day: 'Jour',
    month: 'Mois',
    year: 'Année',
    configYear: 'Année',
    configMonth: 'Mois',
    configDay: 'Jour',
    week: 'Semaine',
    energyAll: 'Énergie totale',
    accounted: 'Proportion',
    energyRate: "Taux d'économie d'énergie",
    designTotalEnergy: 'Énergie prévue',
    realityTotalEnergy: 'Énergie réelle',
    week1: 'Lun',
    week2: 'Mar',
    week3: 'Mer',
    week4: 'Jeu',
    week5: 'Ven',
    week6: 'Sam',
    week7: 'Dim',
    January: 'Jan',
    February: 'Fév',
    March: 'Mar',
    April: 'Avr',
    May: 'Mai',
    June: 'Jun',
    July: 'Juil',
    August: 'Août',
    September: 'Sept',
    October: 'Oct',
    November: 'Nov',
    December: 'Déc',
    exportConfirm: "Confirmer l'exportation",
    enterLimits: 'Veuillez saisir toutes les limites',
    gpNoNotempty: 'Le numéro de groupe ne peut pas être vide',
    selectAreaName: 'Sélectionner le nom de la zone',
    shangHai: 'Shanghai',
    beiJing: 'Pékin',
    guangZhou: 'Guangzhou',
    noAreaPermission: "La configuration ne peut pas être effectuée en raison de l'absence d'autorisations pour la zone. Veuillez contacter l'administrateur pour obtenir les autorisations nécessaires"
  },
  monitorMap: {
    deviceDetail: "Détails de l'appareil",
    childDeviceRelation: 'Topologie des sous-appareils',
    entryIconMonitorMapTip: "Aller au plan d'étage",
    entryIconMonitorListTip: "Quitter le moniteur de plan d'étage",
    equipmentOverview: 'Aperçu des appareils',
    energyManage: "Gestion de l'énergie",
    spaceUtilization: "Utilisation de l'espace",
    openOrClose: 'Marche/Arrêt',
    onlineCount: 'Nombre en ligne',
    offlineCount: 'Nombre hors ligne',
    alarm: 'Alarme',
    spaceUtilizationShow: "Affichage de l'utilisation de l'espace",
    spaceUtilizationRank: "Classement de l'utilisation de l'espace",
    percentageRankDesc: 'Ordre décroissant par pourcentage',
    spaceMotionShow: "Démonstration de l'occupation de l'espace",
    spaceMotionDetail: "Détails de l'utilisation de l'espace",
    collapse: 'Plier',
    motionAreaRank: 'Salle triées par occupées/inoccupées',
    switchSpaceUtilizationSuccess: "Le mode plan d'étage est passé en mode utilisation de l'espace !",
    switchSpaceMotionSuccess: "Le mode plan d'étage est passé en mode occupation de l'espace !",
    totalDay: 'Total du jour',
    totalMonth: 'Total du mois',
    totalYear: "Total de l'année",
    noBindArea: "Cette zone n'est pas encore définie, veuillez d'abord la tracer sur la carte, puis la définir.",
    noCurrentImg: 'Cette zone ne figure pas dans le dessin actuel, veuillez passer à ce dessin.',
    min: 'Min',
    max: 'Max',
    quarterStart: 'Début du trimestre',
    quarterEnd: 'Fin du trimestre'
  },
  baoliMap: {
    projectBoard: 'Aperçu des projets',
    mapMode: "Mode Plan d'étage",
    listMode: 'Mode Liste',
    defaultSort: 'Classement par défaut',
    warnNumber: 'Total des alertes',
    timeEnergy: 'Énergie en temps réel',
    lightNumber: 'Nombre total de lumières allumées',
    today: "Aujourd'hui",
    nowYear: 'Cette année',
    LightingRate: 'Pourcentage de lumières allumées',
    entryProject: 'Afficher le projet',
    energyConsumption: "Rapport d'énergie",
    deviceNumber: "Nombre d'appareils"
  },
  limite: {
    choose: 'Rôle',
    finsh: 'Effectué',
    Functional: 'Autorisations fonctionnelles',
    index: 'Index',
    project: 'Détails du projet',
    monitoring: 'Surveiller',
    lighting: 'Contrôle de l\'éclairage',
    areaLimit: 'Zone',
    movename: 'Zone',
    onewarn: 'Veuillez sélectionner au moins une zone',
    ifttt: 'Automatisation',
    qrcode: 'Code QR',
    install: 'Installation d\'appareils',
    failureList: 'Alertes sur les appareils',
    waring: "L'utilisateur # pourra ajouter, supprimer, déplacer et remplacer des appareils.",
    waring1: "Vous accordez à l'utilisateur # l'autorisation de gérer les appareils.",
    ok: 'Confirmer',
    cancel: 'Annuler'
  },
  adddevice: {
    maintenance: "Fonctionnalité de l'appareil en cours de maintenance, veuillez réessayer plus tard !",
    add: 'Ajouter un appareil',
    back: 'Retourner à',
    move: 'Déménagement',
    addto: 'Ajouter',
    realdevice: 'Dispositif',
    realgateway: 'Boîtier Smart Connect',
    virtualthirdparty: 'Vir-Tiers',
    virtualdevice: 'Appareil Vir',
    virtualgateway: 'Passerelle virtuelle',
    realthirdparty: 'Tiers',
    ethernet: 'Appareil Ethernet',
    findQcode: 'Veuillez trouver le code QR au dos du produit',
    teleQcode: "Utilisez votre téléphone pour scanner le code QR afin d'obtenir la chaîne de 80 bits",
    example: 'Par exemple',
    enoceanInfo: "La partie en rouge correspond à l'adresse MAC de cet appareil et la partie en vert à la clé du répéteur.",
    copyInsert: "Copiez l'intégralité de la chaîne de 80 bits sur votre ordinateur et remplissez le champ correspondant.",
    selectDeviceType: "Sélectionnez le type d'appareil",
    enterDeviceName: "Saisissez le nom de l'appareil pour effectuer la recherche",
    MacAddress: 'Adresse MAC et clé',
    findString: 'Comment trouver la chaîne de caractères ?',
    qcString: "Veuillez saisir la chaîne de caractères du code QR figurant sur l'étiquette au dos du produit",
    retry: 'Sélectionner à nouveau',
    configure: 'Aller dans Configurer',
    failDevice: "L'ajout d'un appareil a échoué, veuillez vérifier si la chaîne de caractères est correcte.",
    successDevice: "Ajout réussi. Pour garantir le fonctionnement normal de l'appareil, il est nécessaire de sélectionner la lampe comme nœud répéteur. Veuillez vous rendre sur la page des détails de l'appareil pour effectuer ce réglage.",
    midConfig: 'Configuration du répéteur',
    secret: 'Clé secrète',
    noDevice: 'Aucun appareil',
    requires32characters: '32 caractères requis',
    moveTitle: 'Souhaitez-vous déplacer tous les appareils dans cette pièce par défaut ? Si vous préférez ne pas les déplacer maintenant, vous pourrez le faire plus tard dans la zone non attribuée.',
    movebnt1: 'Ne pas déplacer maintenant',
    movebnt2: 'Déplacer',
    addMaxDeviceTitle: "Prise en charge de l'ajout de {{max}} appareils au maximum",
    noDeviceTitle: "Aucun appareil ne peut être configuré comme nœud répéteur ou leur version de micrologiciel est trop ancienne ; vous devez d'abord effectuer une mise à jour, puis le configurer comme nœud répéteur.",
    noAddTitle: "Il n'y a pas de boîtier de connexion prenant en charge cette fonction, ou sa version de micrologiciel est trop ancienne ; une mise à jour est nécessaire avant l'appairage.",
    addSuccess: 'Les dispositifs ont été appariés avec succès.',
    outRang: 'Hors de portée',
    least: 'Au minimum',
    upTo: 'Au maximum',
    subDevice: 'Sous-appareil de la passerelle',
    tianmu: 'Écran'
  },
  courseDataySync: {
    current: 'État de synchronisation',
    history: 'État de synchronisation',
    title: 'Synchronisation des données',
    error: 'État de synchronisation',
    tipInfo: "Par défaut, l'appareil sera déplacé dans cette pièce. Êtes-vous sûr ?",
    reset: 'Réinitialiser'
  },
  tree: {
    exportExcel: "Importer l'arborescence des zones à partir d'un fichier Excel",
    downloadTemplate: 'Télécharger    le modèle',
    excelInfo: "Si vous n'avez pas modifié l'arborescence des zones, téléchargez le modèle et modifiez-le en respectant le format",
    excelTemplateName: "Modèle d'arborescence des zones",
    uploadTemplate: 'Télécharger',
    uploadType: 'Prise en charge des fichiers .xlsx et .xls uniquement',
    moveHere: 'Glisser-déposer les fichiers ici pour les remplacer',
    title: 'Nœud de contrôle',
    replaceExcel: 'Remplacer le fichier',
    uploadTime: 'Heure de téléchargement',
    plhode1: 'Saisir un mot-clé pour filtrer',
    updatewaring: "Veuillez d'abord terminer votre tâche en cours",
    city: 'Area',
    placeholdertree: 'Rechercher',
    submit: 'Confirmer',
    cancle: 'Annuler',
    delmsg: 'Êtes-vous sûr de vouloir supprimer la zone ?',
    addmsg: 'Ne peut pas être vide',
    treeMenuShowTip: "Réduire l'arborescence des zones",
    selfArea: 'Cette zone',
    subArea: 'Sous-zone',
    nopermission: `Aucune autorisation pour la zone sélectionnée. Les informations de zone ne peuvent pas être affichées. Contactez l'administrateur si nécessaire.`
  },
  scene: {
    singleDeviceOne: 'Une seule scène peut être sélectionnée pour un appareil donné',
    singleDevice: "Scène d'un seul appareil",
    onlyQuerySingle: "Rechercher uniquement les scènes d'un seul appareil",
    queryNonSingle: 'Rechercher les scènes de plusieurs appareils',
    allScenarios: 'Toutes les scènes',
    sceneNo: 'ID de scène.',
    masterControl: 'Commande principale.',
    partialControl: 'Contrôle partiel',
    tianmuNoGo: "La scène « Sky Ceiling » n'est pas modifiable",
    noFade: 'Pas de gradient',
    question: "L'appareil DALI ne prend pas en charge le temps de fondu de scène",
    deviceTypes: "Veuillez sélectionner le type de protocole de l'appareil",
    bluetooth: 'Bluetooth',
    converter: 'Convertisseur BLE-DALI',
    sceneSelect: 'Sélectionner une scène',
    searchPlhode1: 'Nom/mot-clé de la scène',
    lastScene: "Dernière scène activée Heure d'exécution",
    lastSceneTime: 'Heure de fonctionnement',
    lastSceneNone: 'Aucune scène à exécuter',
    title: 'Scénarios',
    plhode2: 'Nom/Mac',
    plhode1: 'Veuillez entrer le nom du scénario',
    add: 'Ajouter',
    adddevice: 'Ajout de dispositifs en cours',
    caozuo: 'Opération',
    remove: 'Déménagement',
    del: 'Effacer',
    dele: 'Effacer',
    power: 'Définir la puissance maximale',
    cancel: 'Annuler',
    all: 'Aucune',
    allno: 'Sélectionner tout',
    powerinfo: 'La puissance maximale est de',
    yes: 'Oui',
    state: 'État :',
    block: 'Zone :',
    go: 'Aller à',
    deltext: 'Êtes-vous sûr de vouloir supprimer ?',
    ok: 'Confirmer',
    control: 'control',
    controlsingle: 'Contrôler',
    device: 'Dispositif',
    gateway: 'Boîtier Smart Connect',
    deviceSelect: "Sélection d'un appareil",
    selectScence: 'Au moins 1 scène doit être sélectionnée',
    blockSelect: 'Sélectionner les zones',
    roomwarn: "Cette action ne peut être effectuée qu'au niveau de la pièce",
    areawarn: "Cette action ne peut être effectuée qu'au niveau de la zone",
    powerOnInitState: 'Régler la puissance de gradation',
    lampGradual: 'Définir la durée de fondu',
    lampLinkagePanel: "Définir l'interrupteur pour contrôler les lumières",
    sensorExtTime: 'Définir le délai du capteur',
    powerOnInitStateInfo: 'Gradation',
    lampGradualSwitchInfo: "Fonction de fondu de l'appareil",
    lampGradualExtimeInfo: "La durée de fondu de l'appareil est de",
    sensorExtTimeInfo: 'Le délai du capteur est de',
    blockSelectLimitTips: 'Astuce : actuellement, vous ne pouvez sélectionner que 5 zones au maximum !',
    blockOneSelect: 'Choisissez une zone',
    blockMoreSelect: 'Choisissez plusieurs zones',
    gatewayDeleTip: "L'appareil supprimé contient une passerelle. Une fois la passerelle supprimée, l'appareil associé à celle-ci sera également supprimé",
    batchResetInfo: 'Définir le mode de réinitialisation sur',
    batchResetTypeNormal: 'Mode Normal',
    batchResetTypeExpert: 'Mode professionnel',
    batchReset: 'Définir le mode de réinitialisation',
    batchConfigurePowerOnState: "Définir l'état d'alimentation",
    PowerOnState: 'État de la mise sous tension',
    PowerOnStatePrecious: 'Dernier état',
    PowerOnStateFixed: 'Statut fixe',
    open: 'Ouvrir',
    close: 'désactivez',
    selectSceneToCopy: 'Copier la scène',
    lightCount: 'Nombre de blocs LED',
    areaMapping: "Veuillez configurer le mappage des zones avant d'exécuter la scène",
    goConfig: 'Allez le configurer',
    projectConfig: 'Configuration du projet',
    batchConfig: 'Configuration par lots',
    batchCLO: 'Définir le paramètre CLO',
    DaliSulv: 'Définir le taux de fondu DALI',
    batchCLOTips: 'Paramètre CLO',
    setBatchCLO: 'Paramètres CLO',
    NoFadeSupport: 'Les appareils suivants ne prennent pas en charge la fonctionnalité [Durée de fondu]. Veuillez rétablir la durée de fondu par défaut.',
    FadeSupportAfterUpgrade: 'Les appareils suivants prendront en charge la fonctionnalité de durée de fondu après la mise à jour',
    WebImageScene: "Scène d'image Web",
    defaultFadeByScene: "L'état par défaut suit la durée de fondu de l'appareil définie dans la configuration de la scène",
    fadeTime: 'Temps de fondu',
    sensorSensitive: 'Régler la sensibilité du capteur',
    sensitivity: 'Sensibilité',
    batchRename: 'Renommer les canaux par lots',
    LevelPerSecond: '{num} niveaux/s'
  },
  tianmu: {
    minutes: 'Minutes',
    onlyOneTime: 'Un seul appareil peut être sélectionné',
    devicePlaying: 'Appareil en cours de lecture...',
    paused: 'En pause',
    times: 'fois',
    onlyFiveVedio: "Seules 5 vidéos sont prises en charge. Si vous souhaitez poursuivre le téléchargement, veuillez d'abord supprimer les autres vidéos",
    noSolution: 'Aucune solution trouvée',
    noDownloadedVideo: 'Aucune vidéo téléchargée disponible. La lecture ne peut pas continuer.',
    estimate: 'estimation',
    clickToRetry: 'Cliquez pour réessayer',
    static: 'statique',
    dynamic: 'dynamique',
    noVideo: 'Aucune scène vidéo sélectionnée',
    customEditing: 'Édition personnalisée',
    equipmentSchematic: "Schéma de l'équipement",
    schemeAccepted: 'Schéma accepté',
    chooseNumber: "Choisir 1 parmi $$",
    multipleChoice: 'Choix multiple',
    master2: 'deux',
    master3: 'trois',
    master4: 'quatre',
    master5: 'cinq',
    notSupported: 'Non pris en charge',
    maxSizeUniform: 'Taille maximale : {max}m',
    maxSizeSides: 'Exigences : un côté ≤ {maxLong}m, l\'autre côté ≤ {maxShort}m',
    minSizeUniform: 'Taille minimale : {min}m',
    minSizeLampSides: 'Exigences : un côté ≥ {minLong}m, l\'autre côté ≥ {minShort}m',
    circle: 'Cercle',
    radius: 'rayon',
    irregular: 'Forme irrégulière',
    moduleMatch: 'Correspondance des modules',
    launchDate: 'Date de lancement',
    shapeSelection: 'Sélection de la forme',
    sdlModule: 'Module SDL',
    sdlModuleSingle: 'Module unique (75*75mm)',
    sdlModuleCombo: 'Correspondance automatique du meilleur assemblage (75*75mm, 100*600mm, 600*600mm)',
    lampModule: 'Module luminaire',
    lineModule: 'Module linéaire',
    faceModuleTooltip: 'Conception intégrée, adaptable aux grandes surfaces murales, de plafond ou de sol',
    lampModuleTooltip: 'Conçu pour divers besoins d’éclairage. Prend en charge l’installation d’un module unique et l’assemblage libre de plusieurs unités pour murs, plafonds, sols, etc.',
    lineModuleTooltip: 'Pratique et esthétique. Idéal pour couloirs de bureaux, décorations linéaires d’hôtels, éclairage de bordures en retail et signalétique — pour un rendu linéaire net et allongé',
    uploadDrawing: 'Téléverser un plan',
    windowShadow: 'Avec ombre de fenêtre',
    noWindowShadow: 'Sans ombre de fenêtre',
    singleOffset: 'Décalage simple',
    doubleOffset: 'Décalage double',
    directDown: 'Éclairage vertical',
    lockedConfiguration: 'Configuration verrouillée',
    ceilingCurtainDevice: 'Écran',
    Row: 'Ligne',
    Column: 'Colonne',
    layout: 'Disposition',
    mainDevice: 'Maître',
    slaveDevice: 'Esclave',
    testDescribe: 'Description du test',
    InstallationDiagram: "Schéma d'installation et de câblage",
    power: 'Puissance',
    square: 'Forme carrée',
    ceilingCurtain: "Configuration de l'éclairage de rideau de plafond",
    lineDir: 'Sens de câblage',
    lightSources: 'Espacement entre les sources lumineuses adjacentes',
    lightSourceDistribution: 'Répartition des sources lumineuses',
    lineMap: 'Schéma de câblage global',
    a3Info: "Pour l'impression des plans, il est recommandé d'utiliser le format A3 avec une impression en couleur.",
    constructionDepth: 'Profondeur de construction',
    solutionModuleInvalid: 'La longueur et la largeur actuelles dépassent la plage de ce module.',
    solutionModuleMinInvalid: 'La longueur et la largeur actuelles sont inférieures à la plage de ce module.',
    realPhotoProduct: 'Spécifications réelles du produit',
    realPhoto: 'Effet réel',
    thicknessDeep: 'Épaisseur (profondeur de la rainure)',
    specifications: 'Spécifications',
    exportsing: 'Exportation : veuillez patienter, cela peut prendre un certain temps',
    installation: "Conditions d'installation",
    canvasInfo1: 'Les sources lumineuses SDL doivent être disposées de manière uniforme conformément aux spécifications du plan, avec un espacement régulier entre les sources adjacentes.',
    canvasInfo2: `La goulotte de plafond doit être construite à partir de planches de bois et peinte en blanc. La profondeur de la goulotte doit être de $$ mm, et l'intérieur doit être protégé contre la poussière, sans trous ni interstices inutiles.`,
    canvasInfo3: "Le panneau d'accès au driver et au contrôleur doit être situé près du rideau de plafond, avec les câbles d'alimentation préinstallés.",
    canvasInfo4: 'La distance entre le driver et le module optique ne doit pas dépasser 5 mètres, et le câble doit avoir une section de 1,0 mm² ou plus.',
    canvasInfo5: 'Lorsque le nombre de pixels d’un circuit dépasse 80, il est recommandé d’ajouter une alimentation complémentaire aux deux extrémités.',
    designerTools: 'Outils de conception',
    skyCeilingDesign: 'Conception de plafond Sky',
    pointPreview: 'Aperçu des points',
    faceModule: 'Module de surface',
    workbenchZoomDrawing: 'Zoom du plan',
    workbenchFilmLimit: 'Limite de film',
    workbenchFilmLimitValue: '4.2m',
    myDesigns: 'Mes conceptions',
    createNewDesign: 'Créer une nouvelle conception',
    share: 'Partager',
    viewDetails: 'Afficher les détails',
    designName: 'Nom de la conception',
    placeholderDesignName: 'Veuillez saisir le nom du projet',
    createShape: 'Créer une forme',
    specSettings: 'Paramètres de spécification',
    width: 'Durée',
    thicknessSlotDepth: 'Épaisseur (profondeur de la rainure)',
    maintenanceHatchPosition: 'Position de la trappe de maintenance',
    systemSettings: 'Paramètres système',
    systemRecommend: 'Recommandation système',
    shortSide: 'Côté court',
    longSide: 'Côté long',
    effectPreview: "Aperçu de l'effet",
    maintenanceHatch: 'Trappe de maintenance',
    lightDensity: 'Densité des sources lumineuses',
    selectControllerType: 'Sélectionner le type de contrôleur',
    singleChannelController: 'Contrôleur à canal unique',
    dualChannelController: 'Contrôleur à double canal',
    previewSceneLibrary: 'Aperçu Bibliothèque de scènes',
    export: 'Exporter',
    lightSourceInfo: 'Informations sur les sources lumineuses',
    billOfMaterials: 'Nomenclature',
    lightDistributionDrawing: 'Schéma de répartition de la lumière',
    view: 'Vérifiez',
    area: 'Surface',
    lightingBlockchainCount: "Nombre de blocs d'éclairage",
    controllerCount: 'Nombre de contrôleurs',
    powerSupplyCount: "Nombre d'alimentations électriques",
    maxPower: 'Puissance maximale',
    productName: 'Nom du produit',
    partNumber: 'Référence',
    description: 'Description',
    quantity: 'Quantité',
    inputSpec: "Spécifications d'entrée",
    generateSolution: 'Générer une solution',
    previousStep: 'Étape précédente',
    complete: 'Effectué',
    nextStep: 'Suivant',
    exit: 'Se déconnecter',
    bluetooth: 'Bluetooth',
    imagesOnly: 'Images uniquement',
    imagesAndVideosOnly: 'Prend en charge les scènes image et vidéo',
    canopyMaxLengthNotice: 'Une seule verrière peut couvrir une longueur maximale de 15 m. Les longueurs supérieures à 15 m seront segmentées',
    canopyMaxWidthNotice: 'Une seule verrière peut couvrir une largeur maximale de 4,2 m. Les largeurs supérieures à 4,2 m seront segmentées',
    maintenancePortInstruction: "Le système recommandera automatiquement l'emplacement optimal",
    lightDensityDescription: 'Plus la densité des sources lumineuses est élevée, plus les détails de la scène sont fins, mais le coût est également légèrement plus élevé',
    high: 'élevé',
    middle: 'Moyenne',
    low: 'Faible',
    delete: 'Effacer',
    size: 'Taille',
    nameLengthLimit: 'Le nom ne peut pas dépasser 15 caractères',
    nameRequired: 'Veuillez saisir un nom',
    shuangluPoint: 'Le nombre réel de points {{num}} ne correspond pas au nombre actuel de points',
    oneKeyUpLevel: 'Mise à niveau en un clic',
    childDevice: 'Appareil enfant',
    lightLibrary: "Bibliothèque d'effets d'éclairage",
    upImageTip: "Conseil : l'image sera redimensionnée de manière adaptative en fonction de la taille de l'appareil.",
    customizeName: 'Nom personnalisé',
    configTip: 'Configuration en cours, veuillez réessayer plus tard',
    unbindTips: 'Après avoir dissocié la solution, tous les appareils enfants associés seront supprimés, et les scènes et automatisations associées seront effacées. Voulez-vous vraiment continuer ?',
    reBuildTips: 'Après avoir redessiné la position du point, les scènes et automatisations associées seront effacées. Voulez-vous vraiment continuer ?',
    delTips: "Après la suppression de l'appareil, tous les appareils enfants associés seront dissociés, et les scènes et automatisations associées seront effacées. Voulez-vous vraiment continuer ?",
    delTips2: 'Les appareils à supprimer incluent les appareils de puits de lumière. Après la suppression, tous les appareils enfants associés seront dissociés, et les scènes et automatisations associées seront effacées.',
    channelCount: 'Nombre de canaux',
    pointCount: 'Nombre de points',
    addTianmuDevice: 'Ajouter un appareil Tianmu',
    guanlian: 'Associé',
    bindPlan: 'Associer un forfait',
    bindDevice: 'Appareils  associés',
    bindPlanTitle: 'Veuillez sélectionner un forfait associé au compte actuel',
    bindDeviceTitle: "Veuillez sélectionner l'appareil à associer",
    bindDeviceWarning: "Veuillez sélectionner l'appareil à associer",
    shareWarning: 'Veuillez saisir les coordonnées du destinataire',
    shareWarning1: 'Veuillez saisir un numéro de téléphone au format valide',
    shareWarning2: 'Veuillez saisir une adresse e-mail au format valide',
    successMsg: 'Partage réussi',
    shareTitle: 'Partage du forfait Tianmu',
    notice: 'Notifications',
    sizeDesignNotAllowed: 'La taille ne peut pas être définie',
    chooseOneOfTwo: "Choisissez l'une des deux options",
    uploadVideo: 'Télécharger une vidéo',
    videoSize: 'Format MP4, taille inférieure à 150 Mo, durée ne dépassant pas 1 minute',
    onlyMp4Format: "Le format de fichier n'est pas pris en charge",
    onlyVideoSize: 'La taille du fichier dépasse 150 Mo',
    onlyVideoTime: 'La durée du fichier dépasse 1 minute',
    importVideo: 'Importer une vidéo',
    upVideoTip: "La vidéo s'adaptera automatiquement à la taille de l'appareil.",
    overflowTip: 'La scène est pleine. Veuillez supprimer un élément et réessayer.',
    sure: 'Confirmer',
    configurationSchemeCannotDelete: 'Le schéma dans la configuration ne peut pas être supprimé.',
    maxScenesLimit: 'Seules 5 scènes vidéo peuvent être diffusées.',
    productModel: 'Modèle de produit',
    controllerType: 'Type de contrôleur',
    createStandard: 'Créer un plan produit standard',
    standard: 'Solution produit standard',
    office: 'Bureau',
    addDescription: 'Veuillez ajouter une description',
    aiCreate: "L'IA est en train de générer l'image...",
    atUploading: 'Téléversement en cours...',
    historyList: 'Historique',
    uploadFailed: 'Échec du chargement, veuillez réessayer',
    qualityLight: 'Éclairage premium',
    UploadIorV: 'Téléverser une vidéo / une image',
    aiCreateTip: 'Partagez vos idées créatives ou des images intéressantes pour générer des effets lumineux IA exclusifs !',
    sceneDescription: "Veuillez saisir une description d'effet lumineux, par ex. : soleil du matin, lueur du coucher de soleil",
    myCreation: 'Mes créations',
    enterNow: 'Entrer maintenant',
    newConversation: 'Nouvelle conversation',
    aiCreating: 'Génération par IA en cours',
    aiFailed: 'Échec de la génération par IA',
    imageEditing: "Édition d'image",
    generatedImage: 'Image générée',
    devicePreview: "Aperçu de l'appareil",
    saveToMyCreations: 'Enregistrer dans Mes créations',
    picHasSaved: "L'image a été enregistrée dans Mes créations",
    creativeDescription: 'Veuillez saisir votre description créative',
    sunsetGlow: 'Lueur du coucher de soleil',
    snowCcovered: 'Neige épaisse',
    groupSpacing: 'Espacement des groupes',
    addArray: 'Ajouter un réseau',
    arrayInfo: 'Informations sur le réseau',
    arrayN: 'Réseau {n}',
    duplicateArrayLength: 'La longueur {length} existe déjà. Veuillez choisir une autre longueur',
    lineLightLength: 'Longueur du luminaire linéaire',
    arrayCount: 'Quantité de réseaux',
    densityModalDesc: 'Plus la densité des sources est élevée, plus l’éclairement le long du mur est élevé, et plus le coût l’est également',
    implementationSpec: 'Spécifications du produit réel',
    highDensity: 'Haute densité',
    middleDensity: 'Densité moyenne',
    lowDensity: 'Faible densité',
    radiusLessThanMaxLen: 'Le rayon doit être supérieur à la longueur maximale du réseau {maxLen}m',
    radiusRequired: 'Le rayon ne peut pas être vide et a été réinitialisé selon la configuration du réseau',
    circleArrayEmpty: 'Veuillez ajouter les informations du réseau, puis cliquer sur « Appliquer » pour l’aperçu des points',
    arrayRequired: 'Les informations du réseau de luminaires linéaires ne peuvent pas être vides',
    arrayFieldRequired: 'La longueur du luminaire linéaire ou la quantité de réseaux ne peut pas être vide',
    arrayApplyRequired: 'Veuillez d’abord cliquer sur « Appliquer » pour générer l’aperçu des points',
    arrayLayoutInvalid: 'La validation de la disposition du réseau a échoué. Veuillez ajuster et réessayer',
    wellSky: 'Well Sky',
    xidingDeng: 'Luminaire suspendu',
    canDiao: 'Luminaire de table',
  },
  sceneTemplate: {
    warningTemplateTextAuto1: "Vérifiez s'il y a des luminaires dans la zone actuelle",
    warningTemplateTextAuto2: "Vérifiez s'il y a des capteurs ou panneaux dans la zone actuelle",
    warningTemplateTextAuto3: `Si les conditions 1 et 2 sont remplies mais qu'il n'y a toujours pas de données, aucun modèle n'est disponible pour ce secteur`,
    picScene: "Scène d'image",
    titleFreePic: 'Gratuit temporairement !',
    title: 'Modèle de scène OPPLE',
    scheme: 'Modèle de scène',
    preView: 'Aperçu',
    sure: 'Confirmer',
    finished: 'Réussi',
    application: 'Appliquer',
    noMatchedDevice: 'Appareils non compatibles',
    selfDefine: 'Personnaliser scénario',
    templateDefine: 'Scènes rapides',
    warningText: "Il n'y a aucun appareil pris en charge dans la zone que vous avez sélectionnée. Veuillez d'abord ajouter un appareil ou sélectionner une zone contenant un appareil, puis utilisez le modèle de scène !",
    warningTemplateText: "Il n'y a aucun modèle de scène dans la zone que vous avez sélectionnée !",
    autoTitle: "Modèle d'automatisation",
    warningTextAuto: "Il n'y a aucun capteur dans cette zone. Veuillez ajouter un capteur pour pouvoir utiliser les modèles.",
    warningTemplateTextAuto: "Il n'y a actuellement aucun modèle dans l'espace que vous avez sélectionné.",
    lightTripDefine: "Scène d'affichage de la bande lumineuse",
    copyScene: 'Copier la scène',
    tianmu: 'Scène Ciel',
    sceneEffectPreview: 'Aperçu de la scène',
    selectImg: "Veuillez sélectionner un modèle ou une image personnalisée, puis télécharger l'image.",
    imageTemplate: "Modèle d'image",
    customUpload: "Télécharger l'image personnalisée",
    morning: 'Matin',
    silentNight: 'Crépuscule paisible',
    blueSky: 'Ciel bleu et nuages blancs',
    blueSkySun: 'Ciel bleu, nuages blancs et soleil',
    holiday: 'Lumineux',
    sunsetGlow: 'Ciel cramoisi',
    sunset: 'Coucher de soleil',
    risingSun: 'Ensoleillé',
    noNeedPath: 'Pas besoin de tracer un chemin dans la scène circulaire actuelle',
    needPath: "Dans la scène rectangulaire actuelle, veuillez tracer un chemin avant d'enregistrer !",
    lightTripInputLampCount: "Veuillez saisir le nombre de segments d'éclairage par ligne, séparés par une virgule (,), par exemple",
    createImageScenes: "Créer une scène d'image",
    chooseDevice: 'Sélectionnez les appareils à régler',
    tianmu2: 'Écran',
    blueSkyLamp: 'Lumière du ciel',
    selectStyle: 'Sélectionnez le style',
    selectLampType: 'Sélectionnez le type de luminaire',
    select4: 'Veuillez sélectionner 4 pièces',
    lightingParameters: "Paramètres d'éclairage",
    lampMode: 'Mode clair',
    selectColor: 'Sélection de la couleur',
    limit: "Image au format jpg/png jusqu'à 3 Mo",
    screenSplicing: "Assemblage d'écran",
    splicing: 'Assemblage',
    noSplicing: 'Non assemblé',
    originalImage: 'Image originale',
    sdlColor: 'Couleur SDL',
    lightTripOption: 'Paramètres de la bande lumineuse',
    shadowEffect: "Effet d'ombre",
    clearSky: 'Ciel dégagé',
    dawn: 'Aube',
    twilightGlow: 'Lueur crépusculaire',
    blueSkyWhiteClouds: 'Ciel bleu et nuages blancs',
    rainbowAfterRain: 'Arc-en-ciel',
    spring: 'Printemps',
    summerScenery: 'Été',
    cleanSweep: 'Automne',
    winter: 'Hiver',
    blueSkyA: 'Ciel bleu A',
    blueSkyB: 'Ciel bleu B',
    synthesis: 'Fusionner plus de lumières',
    row: 'Nombre de lignes',
    col: 'Nombre de colonnes',
    Round4in1: 'Rond 4 en 1',
    customSize: 'Taille personnalisée'
  },
  devicecard: {
    deviceAndChanel: 'Appareils et canaux',
    offline: 'Hors ligne',
    online: 'En ligne',
    callpolice: 'Alarme',
    malfunction: 'Défaut',
    lifeto: 'Fin de vie',
    attributes: 'Attributs',
    area: 'Zone',
    switchstatus: "État de l'interrupteur",
    light: 'luminosité',
    colortemperature: 'CCT',
    illuminance: 'Éclairement',
    temperature: "Température de l'air",
    movement: 'Occupation',
    humidity: 'Humidité',
    co2: 'CO₂',
    pm: 'PM2,5',
    power: 'Puissance',
    energyconsumption: "Consommation d'énergie",
    remaininglife: 'Durée de vie restante',
    motortravel: 'Course du moteur',
    electricity: 'État de la batterie',
    motorangle: 'Angle du moteur',
    dataing: 'Synchronisation des données',
    identification: 'Identifier',
    plank: 'Tableau de bord actuel',
    selected: 'Sélectionné',
    info: 'Info',
    sameUnmoved: "Vous ne pouvez pas déplacer l'appareil dans la même zone",
    delDeviceInfo: "Veuillez supprimer l'appareil depuis la page Installation.",
    alreadycheck: 'Sélectionné',
    nobind: 'Virtuel',
    dowarn: 'Info',
    refresh: 'Rafraîchir',
    ok: 'Confirmer',
    cancel: 'Annuler',
    nonametip: 'Le nom ne peut pas être vide',
    deviceTotal: 'Appareils',
    gatewayTotal: 'Appareils',
    identifNone: "Cet appareil est un appareil à faible consommation d'énergie ; veuillez vous reporter au guide du produit pour l'identifier.",
    identif1: "Comme indiqué sur l'illustration, appuyez simultanément sur le bouton « ON » situé à l'avant du panneau et sur le bouton « R » situé en bas. À ce moment-là, le voyant LED reste allumé en permanence et l'appareil passe en mode d'attente de mise à jour",
    identif2: 'Appuyer une fois sur le bouton de réinitialisation',
    identif3: `2. La carte d'appareil correspondante dans l'interface utilisateur clignotera trois fois, confirmant l'identification réussie de l'appareil actuel.`,
    noComma: 'Le nom contient des caractères non autorisés « #,# ». Veuillez les supprimer avant de valider'
  },
  sceneCard: {
    mode1: 'Mode fin de journée',
    mode2: 'Mode travail',
    mode3: 'Mode repos',
    mode4: 'Mode nettoyage',
    mode5: 'Mode d\'urgence',
    mode0: 'Aucun',
    state: 'État:',
    block: 'Zone :',
    go: 'Aller à',
    base: 'Informations de base',
    cao: 'Tâche',
    add: 'Ajouter',
    type: 'Icône de la scène',
    name: 'Nom de la scène：',
    alreadydelete: "L'appareil a déjà été supprimé",
    alreadymove: "L'appareil a déjà été déplacé",
    save: 'Sauvegarder',
    back: 'Retourner à',
    unifiedcontrol: 'Tout contrôler',
    up: 'Monter',
    down: 'Descendre',
    lightSwitch: 'ALLUMÉ/ÉTEINT',
    colorWarm: 'CCT',
    color: 'Couleur',
    light: 'luminosité',
    openLight: 'Lumière ON',
    closeLight: 'Lumière OFF',
    selected: 'Sélectionné',
    configuration: 'Réglage',
    allsuccess: 'Réussite totale',
    onesuccess: 'Partiellement réussi',
    allfail: 'Tous échouent',
    invalid: 'Invalide',
    select: 'Sélectionner',
    all: 'Sélectionner tout',
    clear: 'Effacer',
    sceneId: 'ID :',
    joinYes: 'Activer',
    joinNo: 'Désactiver',
    dim: "Dim d'étape",
    dimmingDown: 'Assombrir',
    dimmingUp: 'Éclaircir',
    cct: 'Étape CCT',
    cctWarm: 'Réchauffer',
    cctCold: 'Refroidissement',
    selectDevice: 'Choisir un appareil',
    readReprot: 'Vérifiez',
    expandDeviceList: 'Développer la liste des appareils',
    allon: 'Tout allumer',
    alloff: 'Tout éteindre',
    lightTripImg: 'Informations sur les scènes des bandes lumineuses',
    lightTripRankImg: 'Disposition des bandes lumineuses',
    lightTripCanvasInfo2: "Sélectionnez une bande lumineuse et tracez-la dans la zone d'édition centrale.",
    lightTripCanvasInfo3: 'Lorsque vous tracez plusieurs bandes, essayez de les aligner aussi régulièrement que possible.',
    lightTripCanvasInfo4: "Assurez-vous que toutes les bandes lumineuses sont tracées à l'intérieur de la zone graphique.",
    lightTripCanvasDraw: 'Tracer des chemins',
    lightTripCanvasEdit: 'Modifier le chemin',
    lightTripCanvasDelete: 'Supprimer le chemin',
    lightTripCanvasBack: 'Annuler le chemin',
    lightTripRightAngle: 'Mode angle droit',
    lightTripCanvasDrawInfo: "Lorsque cette option est activée, cliquez avec le bouton gauche pour ajouter un point d'ancrage et avec le bouton droit pour terminer le tracé.",
    lightTripCanvasEditInfo: 'Lorsque cette option est activée, la souris permet de faire glisser les segments de ligne du chemin.',
    lightTripCanvasDeleteInfo: 'Lorsque cette option est activée, vous pouvez supprimer le chemin actuellement sélectionné.',
    lightTripCanvasBackInfo: "Lorsque cette fonction est activée, rétracter le tracé d'un pas",
    size: 'taille',
    lightTripInputLampCount: 'Veuillez saisir le nombre de LED',
    lightCount: 'Nombre de blocs LED',
    line: 'ligne',
    circle: 'Cercle',
    senceWarning: "Avant d'enregistrer, veuillez ajuster l'état de l'appareil pour qu'il corresponde à la page !",
    noEdit: "La scène actuelle ne prend pas en charge la fonction d'édition.",
    noCopy: "La scène actuelle ne prend pas en charge la fonction de copie.",
    workStatus: 'Statut de travail',
    sceneNumber: 'Numéro de situation',
    sensor: 'Sens',
    alwaysOpen: 'Toujours activé',
    alwaysClose: 'Toujours désactivé',
    sleep: 'Veille',
    leastOne: 'Conserver au moins un appareil',
    noAvailableDevice: 'Aucun appareil disponible',
  },
  install: {
    configTip: 'Conseils de configuration',
    measuringDeviceTip1: "Une fois l'appareil connecté, veuillez suivre les étapes ci-dessous pour configurer les zones et les objets de l'outil de mesure.",
    measuringDeviceTip2: 'Cliquez sur « Configuration des paramètres » sur la page de surveillance.',
    measuringDeviceTip3: "Configurez la zone de statistiques et l'objet de l'appareil dans « Configuration des statistiques énergétiques ».",
    deviceHasAtRoom: "L'appareil se trouve déjà dans cette pièce",
    otaToolTip: 'Intensité du signal BLE',
    otaTipTitle1: "Veuillez mettre à jour le(s) appareil(s) ci-dessous avec le dernier firmware avant de le(s) déplacer et de l'utiliser !",
    otaTipTitle11: 'Une fois la mise à jour réussie :',
    otaTipTitle12: "1. Accédez à « Zone non attribuée » dans l'onglet « Installation » à gauche.",
    otaTipTitle13: "2. Faites défiler vers le bas dans l'arborescence des zones/la structure des pièces et cliquez sur « Zone non attribuée ».",
    otaTipTitle14: "3. Déplacez les appareils à l'aide de la fonction « Tâche » dans le coin supérieur droit.",
    otaTipTitle15: '4. Sélectionnez les appareils et cliquez sur « Déplacer ».',
    otaTipTitle2: "Rendez-vous sur Google Play ou l'App Store pour télécharger l'application OPPLE Smart Lighting.",
    otaTipTitle3: 'Il est recommandé de mettre à jour le micrologiciel vers la dernière version avant de procéder au déplacement.',
    otaTipTitleBatchAll: 'Les # appareils suivants doivent être mis à jour vers la dernière version du micrologiciel ! Veuillez vous rendre dans la tâche de mise à jour pour vérifier la progression de celle-ci.',
    otaTipTitleBatch: 'Une fois la mise à jour réussie :',
    otaTipTitleBatch1: "1. Accédez à la section « Zone non attribuée » dans l'onglet « Installation » situé à gauche.",
    otaTipTitleBatch2: "2. Faites défiler vers le bas dans l'arborescence des zones/la structure des pièces et cliquez sur « Zone non attribuée ».",
    otaTipTitleBatch3: '3. Utilisez le bouton « Déplacer en un clic » dans le coin supérieur droit pour déplacer tous les appareils marqués dans la pièce vers la pièce cible.',
    otaTipTitleBatch4: '4. Ou utilisez le bouton « Tâche - Déplacer » dans le coin supérieur droit pour déplacer tous les appareils sélectionnés vers la pièce cible.',
    toWebTip: 'Accéder à la mise à jour Web',
    toAppbTip: "Accéder à la mise à jour via l'application",
    continue: 'Continuer',
    getInfo: 'Compris',
    deviceType: "Type d'appareil",
    protocol: 'Type de protocole',
    typeAname: 'Nom/Mac',
    choose: 'Sélectionner',
    remveblock: 'Déplacer',
    finsh: 'Effectué',
    devicecounterror: 'Sélectionner un appareil',
    areacounterror: 'Sélectionner une zone',
    loading: 'Chargement',
    noarea: 'Dispositifs non attribués',
    truegateway: 'Boîtier Smart Connect',
    truedevice: 'Dispositif',
    powerwarn: 'Veuillez saisir un nombre valide (>0)',
    slelectModifyNameCaption: 'Sélection rapide',
    deviceFilter: 'Filtre des appareils',
    deviceStatus: "État de l'appareil",
    duplicateAreatips: "Veuillez supprimer la scène et l'automatisation de la zone cible avant d'effectuer l'opération de copie",
    duplicateNativeTipInfo: 'Guide de duplication de zone',
    duplicateNativeTipSelectAre: 'Choisissez Zone',
    duplicateNativeTipBind: 'Copier',
    duplicateNativeTipMain: 'Terminer',
    duplicateNativeInfo: 'Veuillez vous assurer que les conditions préalables sont remplies avant de commencer cette étape :',
    duplicateNativeInfo1: 'La zone cible doit contenir des appareils du même type et portant des noms identiques à ceux de la zone source.',
    duplicateNativeInfo2: "Les scènes et automatisations de la zone source ne doivent pas contenir d'appareils qui ont été déplacés ou supprimés.",
    duplicateNativeInfo3: "Veuillez supprimer la scène et l'automatisation de la zone cible avant d'effectuer l'opération de copie.",
    duplicateNativeInfoConfirm: 'Les conditions ci-dessus ont été vérifiées',
    duplicateStart: 'Dupliquer',
    duplicateTargetArea: 'Cette zone',
    duplicateSourceArea: 'Zone source',
    duplicateArea: 'Dupliquer',
    duplicateBindErrorTip: "Les appareils de la zone cible n'ont pas le même nombre, nom ou type que ceux de la zone source. Impossible de passer à l'étape suivante.",
    duplicateBindRelaErrorTip: 'La correspondance entre les appareils est incorrecte.',
    duplicateInfo1: "Il est possible d'avoir plus d'appareils dans la zone cible, mais pas moins que dans la zone source.",
    duplicateInfo2: "Les appareils de la zone cible n'ont pas le même nom ou type que ceux de la zone source. Impossible de passer à l'étape suivante.",
    duplicateInfo3: "Le nombre de périphériques dans la zone cible est inférieur à celui de la zone source. Impossible de passer à l'étape suivante.",
    duplicateInfo4: "Les périphériques des scènes/automatisations correspondent aux paramètres actuels de la pièce. Vous pouvez passer à l'étape suivante.",
    duplicateInfo5: "Les périphériques des scènes/automatisations ont été déplacés/supprimés. Impossible de passer à l'étape suivante. Veuillez d'abord corriger les scènes/automatisations dans la zone source.",
    sceneNumberConfig: 'Configuration du scénario',
    sceneNumberCount: 'ID du scénario Quantité :',
    inputTip: 'saisir le contenu',
    areaMapping: 'Mappage des zones',
    sceneConfig: 'Configuration du scénario',
    duplicateAreaNumber: "Il y a des codes de zone en double, veuillez les vérifier avant d'enregistrer",
    doNotShowThisAgain: 'Ne plus afficher ce message',
    deviceAdded: 'Au total, # appareils ont été ajoutés avec succès.',
    addResult: 'Au cours de cette session, # appareils ont été ajoutés. # appareils ont été déplacés avec succès vers la pièce cible. Les # appareils restants nécessitent une mise à jour du micrologiciel avant de pouvoir être déplacés. Veuillez cliquer sur « Terminer » pour procéder à la mise à jour dans la « Zone non attribuée ». Une fois la mise à jour terminée, ces appareils pourront être déplacés. Si vous souhaitez continuer à ajouter des appareils, veuillez cliquer sur « Continuer »',
    forceUpgrade: 'Mise à niveau forcée',
    batchUpgrade: 'Mise à niveau en un clic',
    batchMove: 'Déplacement en un clic',
    moveOnlyMarked: "Le déplacement en un clic ne déplace que les appareils marqués dans la zone cible",
    noUpgradableDevices: 'Aucun appareil ne peut être mis à jour pour le moment',
    movableDevices: 'Aucun appareil ne peut être déplacé.',
    overwriteTargetWarning: "La pièce cible associée à l'appareil sera écrasée. Voulez-vous continuer ?",
    targetArea: 'Pièce cible',
    aiTokenFailed: "Échec de l'obtention du jeton AI",
  },
  deviceVirtual: {
    span: 'Ajouter un appareil virtuel',
    header: 'Sélectionner une passerelle',
    nextstep: 'Suivant',
    wifitype: 'Sélectionnez un boîtier de connexion intelligent',
    nolinewifi: 'Passerelle Wi-Fi',
    devicetype: "Type d'appareil",
    placeholderone: 'Sélectionner',
    placeholdertwo: 'Veuillez entrer le nom de votre appareil',
    yes: 'Confirmer',
    addwifi: 'Ajouter une passerelle',
    devicetypewarning: 'Sélectionner le type',
    wifitypewarning: 'Sélectionner une passerelle',
    gatewayerror: "Veuillez d'abord ajouter une Smart Connect Box",
    xylx: 'Sélectionner le type'
  },
  deviceMsg: {
    wait: 'En attente...',
    resetRelayDevice: "Réinitialiser l'appareil relais.",
    lightMode1: 'Naturel',
    lightMode2: 'Couleurs',
    lightMode3: 'Lumière du soleil',
    lightMode4: 'Couleur pure',
    lightMode5: 'musique',
    area: 'Zone',
    basicinformation: 'Informations de base',
    devicename: 'Nom du dispositif',
    devicetype: 'Type :',
    devicestatus: "État de l'appareil",
    online: 'En ligne',
    offline: 'Hors ligne',
    agreementtype: 'Type de protocole',
    mac: 'Adresse MAC',
    deviceclassification: 'Référence',
    deviceclassificationname: "Type d'appareil",
    cloudid: 'ID du nuage',
    virtualid: 'ID Vir-cloud',
    createdtime: "Définir l'heure",
    loopid: 'ID du canal',
    loopname: 'Canal',
    devicetypeid: 'Référence',
    more: 'Plus',
    collapse: 'Moins',
    deviceoperating: 'Tâche',
    move: 'Déménagement',
    replace: 'Remplacer',
    delete: 'Effacer',
    factorysetting: "s'il est réinitialisé à la valeur par défaut d'usine.",
    restart: 'Redémarrer',
    stop: 'Arrêt',
    start: 'Démarrer',
    parameter: "Paramètres de l'appareil",
    ota: 'Mise à niveau via OTA',
    currentversion: 'Version actuelle',
    newversion: 'Dernière version',
    uptodate: 'NOUVEAU',
    advancedoptions: 'Options avancées',
    specificversion: 'Version spéciale',
    upgrade: 'Mise à niveau en cours.',
    pause: 'Pause',
    issued: 'Télécharger le fichier',
    initiatefail: 'Échec de la mise à jour',
    ingfail: 'Échec de la mise à niveau.',
    stopfail: "Échec de l'arrêt",
    stopsuccess: 'Arrêt réussi',
    prompt: 'Avis',
    deletedeviceinfor: 'Êtes-vous sûr de vouloir supprimer ?',
    resetdeviceinfor: 'Êtes-vous sûr de vouloir réinitialiser ?',
    restartdeviceinfor: 'Êtes-vous sûr de vouloir redémarrer ?',
    replacedeviceinfor: 'Êtes-vous sûr de vouloir remplacer ?',
    calibratedeviceinfor: 'Êtes-vous sûr de vouloir calibrer ?',
    save: 'Confirmer',
    cancle: 'Annuler',
    configsuccess: 'Réussi',
    configing: 'Réglage',
    configfail: 'Échoué',
    configdefault: 'Défaut',
    hightOption: 'Options avancées',
    specificVersion: 'Version spéciale',
    uppage: 'Haut',
    downpage: 'Bas',
    savesubmit: 'Sauvegarder',
    uplevel: 'Mise à niveau OTA',
    waitForupgrade: 'En attente de mise à jour',
    Upgradeing: 'Mise à niveau en cours.',
    UpgradeSuccess: 'Réussi',
    UpgradeDuplicate: 'En double',
    UpgradeFail: 'Échoué',
    UpgradeConfilct: 'Conflit détecté !',
    UpgradeBusy: 'Occupé',
    UpgradeProjectIdNull: "Aucun numéro de projet",
    parentdevicename: 'Appareil parent',
    calibrate: 'Calibrage',
    calibrateLUX: 'Calibrage de l’éclairement',
    calibrateLUXButton: 'Réinitialiser',
    calibrateLUXTip: 'Calibrage de l’éclairement',
    calibrateTemp: 'Calibrer la température',
    calibrateTempButton: 'Réinitialiser',
    calibrateTempTip: 'Calibrer la température',
    sure: 'Confirmer',
    calibrateBoxTip: "Valeur actuelle de l'éclairage du bureau",
    calibrateHistoryTip: 'Niveau de lux enregistré',
    calibrateAddItem: 'Ajouter un groupe',
    calibrateItemRealityTip: 'Valeur actuelle du capteur',
    calibrateItemInputTip: 'Valeur actuelle du luxmètre',
    calibrateItemWriteTip: 'Veuillez saisir la valeur du luxmètre',
    calibrateItemLimitTip: 'Veuillez ne pas ajouter plus de # enregistrements.',
    otaupdateBleTip: 'Les appareils du même type seront mis à jour en une seule fois. Cela peut prendre plus de 30 minutes par type.',
    isActionPostTitle: 'Aperçu en direct de la scène',
    calibrateTempBoxTip: 'Valeur actuelle de la température du bureau',
    calibrateTempHistoryTip: 'Niveau de température enregistré',
    calibrateTempItemRealityTip: 'Valeur actuelle de la température réelle',
    calibrateTempItemInputTip: 'Température mesurée actuelle',
    calibrateTempItemWriteTip: 'Saisir la valeur de la température mesurée',
    gateWayBoard: 'Carte Maître',
    gateWaySubCard: 'Carte Esclave',
    morefirmwaretip: "Le micrologiciel suivant appartient à l'appareil et ne peut être mis à jour que progressivement.",
    morefirmwareview: "Afficher l'état du dernier micrologiciel",
    canUpgradeingMaster: 'Mise à jour possible',
    firmwareNo: 'Numéro de firmware',
    otabootTrue: 'Les opérations ci-dessus ont été confirmées',
    lengthLimit: 'Veuillez saisir 1-{{length}}caractères.',
    heating: 'Chauffage',
    refrigeration: 'Refroidissement',
    dehumidification: 'Déshumidification',
    airSupply: 'Soufflerie',
    soundOff: 'Silencieux',
    LSpeed: 'Vitesse faible',
    MSpeed: 'Vitesse moyenne',
    HSpeed: 'Vitesse élevée',
    auto: 'Automatique',
    groupPlaceholder: 'Veuillez saisir le numéro du groupe voisin compris entre 0 et 250',
    group: 'Groupe',
    area2: 'zone',
    groupTips: 'Ajouter jusqu\'à 8 groupes voisins',
    colorCustomize: 'Sur mesure',
    cxCyEmpty: 'Veuillez saisir les coordonnées Cx et Cy au format 0.0000, 0.0000',
    cxCyFormatError: 'Veuillez saisir un format de coordonnées valide, par ex. 0.4527, 0.3937',
    cxCyOutOfRange: 'Les coordonnées de couleur dépassent la plage autorisée. Veuillez saisir à nouveau',
    validHexColor: 'Veuillez saisir une valeur de couleur hexadécimale valide',
    rangeOfTheColorPalette: "La valeur de couleur saisie dépasse la plage de la palette de couleurs et a été corrigée pour s'y conformer",
    know: 'confirmé',
    ciexy: 'Coordonnées CIE',
    noRelationDevice: 'Aucun appareil associé pour le moment',
    refreshing: 'Actualisation en cours...',
    refreshFail: "Échec de l'actualisation, veuillez réessayer",
    refreshSuccess: 'Actualisation réussie',
    pleaseSetWifi: "Veuillez d'abord configurer le Wi-Fi dans les paramètres !",
    lengthLimit1: 'Veuillez limiter la longueur du texte',
    lengthLimit2: 'Veuillez limiter la longueur du mot de passe',
    screenSetting: "Paramètres d'écran",
    defaultScreen: 'Écran par défaut',
    maxScreenSettingTips: "Prend en charge jusqu'à {{MaxCount}}",
    keySetting: 'Configuration des boutons',
    keyInput: 'Veuillez saisir le titre du bouton',
    unSetting: 'Non configuré',
    secondDeleteConfirm: 'Les scènes et automatisations liées à #name# et à ses sous-appareils deviendront invalides. Êtes-vous sûr de vouloir les supprimer ?',
    option1: 'Option 1',
    option2: 'Option 2',
    changeBind: 'Modifier la liaison',
    sureOk: 'Confirmation de la fin du processus ci-dessus',
    replaceMain: "Remplacer l'unité maître",
    replaceSlave: "Remplacer l'unité esclave.",
    goodness: "Qualité d'ajustement",
    excellent: 'Excellent',
    makeDo: 'Moyen',
    poor: 'Insuffisant',
    tropic: 'Courbe de régression',
    rawData: 'Données brutes',
    noOtaDevice: 'Aucun appareil pouvant être mis à niveau dans cette zone',
    recommendedValue: 'Valeur recommandée',
    pleaseSelectDataType: 'Veuillez sélectionner le type de données :',
    lightAndPpfd: 'Lumière et densité de flux de photons photosynthétiques (PPFD)',
    channelCountChanged: 'Nombre de canaux modifié ; veuillez vérifier le contrôleur n°{errorIndex}'
  },
  colorPicker: {
    gradient: 'Couleur dégradée',
    gradientNum: 'Sélectionnez au moins {{min}} couleurs.',
    gradientNum2: 'Pas plus de {{max}}'
  },
  deviceChoose: {
    choose: "Sélection d'un appareil",
    group: 'Générer un groupe',
    save: 'Sauvegarder',
    groupwarning: 'Veuillez saisir un nom de groupe',
    sure: 'Confirmer',
    groupsingle: 'Groupe',
    checkwarning: 'Veuillez sélectionner au moins un appareil',
    checkgroupwarning: 'Veuillez vérifier',
    devicestotal: "Quantité d'appareils",
    overStepDeviceGroupTip: 'Si les appareils ne se trouvent pas dans la même zone, le groupe sera enregistré dans la zone spécifiée.',
    chooseDeviceInMap: "Utiliser la sélection du plan d'étage"
  },
  addScenes: {
    work: 'Travail',
    offwork: 'Absent',
    rest: 'Repos',
    sweep: 'Balayage',
    emergency: 'Urgence',
    none: 'Non',
    scenenamewarning: 'Veuillez entrer le nom du scénario',
    actionwarning: "Veuillez sélectionner l'appareil",
    select: 'Sélection',
    isLightActionAutoOpareTip: "Si vous souhaitez que le luminaire s'allume lorsque cette scène est activée, assurez-vous que la fonction « Interrupteur » est activée et que l'interrupteur est réglé sur « On »."
  },
  ifttt: {
    searchPlhode1: "Nom/mot-clé de l'automatisation",
    iftttSetTemplate: 'Important ! Lorsque vous utilisez simultanément une automatisation par capteur et la commande en fonction de la lumière du jour, vous ne pouvez utiliser que le modèle ON*-OFF (sans réglage de la luminosité) !',
    constillumsetTips: "Les appareils ayant participé au réglage automatique de la luminosité ne peuvent pas participer simultanément à une automatisation d'éclairage constant.",
    constillumset: 'Contrôle de la lumière du jour',
    aleadyset: 'Configuré',
    rhythmset: 'Configuration du calendrier',
    customize: 'Automatisation personnalisée',
    template: 'Modèle Bureau',
    clouddo: 'Exécution du cloud',
    proximaldo: 'Exécution sur site',
    success: 'Réussite totale',
    fail: 'Tous échouent',
    ing: 'Réglage',
    custommode: 'Personnalisé',
    illuminationmodel: 'Lumière du jour',
    rhythmode: 'Calendrier',
    manual: 'Exécution manuelle',
    status: "Statut de l'appareil",
    time: 'Heure',
    delcounterror: 'Sélectionnez-en un',
    light: 'Contrôle de la lumière du jour',
    allset: 'Configuré',
    rhythm: 'Configuration du calendrier',
    templateName: 'Ensemble d\'automatisations du département de développement',
    template2: 'Mode personnalisé',
    handle: 'Exécution manuelle',
    templateName2: 'Ensemble d\'automatisations du département de développement',
    rhythm00: 'Sélectionnez un boîtier de connexion intelligent',
    rhythm01: 'Sélectionner le(s) luminaire(s) à régler',
    lightTripOption: 'Réglage des paramètres de la bande lumineuse',
    lightTripSelect: 'Sélectionnez la bande lumineuse à régler',
    lightTripLampCount: 'Veuillez saisir le nombre de LED de la bande lumineuse',
    lightTripDirection: "Veuillez sélectionner le type d'alignement de la bande lumineuse",
    lightTripTransverse: 'Horizontal',
    lightTripVertical: 'Vertical',
    rhythm02: 'Contrôle par programme',
    rhythmLine: 'Courbe de programme',
    set: 'Sur mesure',
    lightDevice: 'Luminaire',
    window: 'Rideau',
    lightName: 'luminosité',
    colorName: 'Température de couleur',
    addTime: 'Ajouter',
    openDegree: 'Degré d\'ouverture',
    Degree: 'Angle',
    info: "OpenDegree : rapport entre la surface des lamelles et la surface totale du volet ; Degree : angle d'ouverture des lamelles du volet.",
    save: 'Sauvegarder',
    upStep: 'Étape précédente',
    yes: 'Confirmer',
    sun: 'luminosité',
    light00: 'Sélectionnez un boîtier de connexion intelligent',
    light01: 'Sélectionner le capteur de lumière du jour',
    light02: 'Sélectionner les luminaires à commande par la lumière du jour',
    light03: 'Exigences',
    light04: 'Étalonnage',
    requirement: 'Exigences',
    requirement01: "Étalonner la valeur d'éclairement du capteur ;",
    requirement02: "Veillez à ce que l'impact de la lumière du soleil sur le capteur ne dépasse pas 70 % lors de l'installation ;",
    requirement03: "Veillez à ce que la lecture du capteur et du luxmètre ne soit pas perturbée au moment de l'installation ;",
    requirement04: "Veuillez saisir la valeur d'éclairement après étalonnage du point de référence.",
    farmingRequirement01: 'Orientez la surface photosensible horizontalement vers le haut, loin des poteaux, arroseurs, luminaires et autres zones obstruées ou exposées aux éclaboussures ;',
    farmingRequirement02: 'Fixez sur un support rigide ; séparez les câbles de signal des câbles d\'alimentation et étanchez les connecteurs ;',
    farmingRequirement03: 'Placez les points de mesure au centre de la zone de culture ; pour les grandes surfaces, déployez plusieurs points par zone ;',
    farmingRequirement04: 'Nettoyez régulièrement le capot photosensible pour éviter que les salissures n\'affectent la précision des mesures.',
    nextStep: 'Suivant',
    luxNum: 'Capteur :',
    watch01: 'Vérifiez votre luxmètre',
    watch02: 'Réglez la gradation du luminaire',
    address: 'Zone',
    standard: "Valeur standard d'éclairement (Lux).",
    timeSet: "Ajustez les propriétés de l'appareil pour différentes plages horaires",
    timeAdd: 'à',
    timeStart: 'Heure de début',
    timeEnd: 'Heure de fin',
    timePlaceholder: 'Intervalle de temps',
    templateState: "Statut de l'appareil",
    execute: 'Exécution du cloud',
    baseMsg: 'Informations de base',
    tempateName: 'Modèle：',
    iftttSet: 'Automatisation',
    rangTime: 'Période effective',
    day: 'Jours ouvrés/tout le temps',
    add: 'Ajouter',
    if: 'Si',
    iftttPlaceholder: 'Sélectionner',
    timing: 'Planification',
    stating: 'Faire',
    delayed: 'Délai',
    minute: 'min',
    statingGo: 'Aller à',
    back: 'Retourner à',
    week: 'Semaine',
    weekpush: 'Jours fériés exclus',
    cancel: 'Annuler',
    timingset: 'Paramètres de temporisation',
    templateManger: 'Gestion des modèles',
    templatetext: 'Modèle',
    templateinfo: 'Ajouter',
    addTemplate: 'Ajouter',
    closeRhythm: 'Désactiver le programme',
    addPanel: 'Ajouter un interrupteur',
    PanelInfo: "Appuyez sur la touche de l'interrupteur",
    dayPlaceholder: 'Sélectionner les données',
    'trigger ': 'Déclencheur',
    introduce: 'Entrer',
    scence: 'Scénarios',
    closeLight: 'Éteindre tous les luminaires',
    trigger: 'Déclencheur',
    open: 'Marche',
    close: 'Arrêt',
    addressText1: 'Salon (activités générales)',
    addressText2: 'Salon (écriture et lecture)',
    addressText3: 'Salle à manger',
    addressText4: 'Salle de lecture',
    addressText5: 'Bureau administratif',
    addressText6: 'Hall de supermarché',
    addressText7: "Salle d'attente d'hôpital",
    addressText8: 'Salles de classe',
    addressText9: "Tableau noir à l'école",
    addressText10: 'Couloir',
    addressText11: 'Usine',
    Illuminance: 'Illuminance',
    color: 'Couleur',
    zdy: 'Veuillez accéder aux paramètres',
    zdylight: 'Veuillez accéder aux paramètres',
    hourxh: 'Mode par défaut (24 h)',
    secondsxh: "Mode d'affichage (24 s)",
    warning1: 'Veuillez sélectionner au moins un appareil',
    warning2: "Veuillez sélectionner une heure d'exécution",
    warning3: "Conflits d'horaires, veuillez sélectionner une heure d'exécution",
    warning4: 'Choisissez une plage horaire pour éviter les conflits',
    no: 'NON',
    iftttSelect: 'Sélectionner une automatisation (ifttt)',
    selectIFTTT: 'Veuillez sélectionner au moins une automatisation (ifttt)',
    openSwitch: 'Marche',
    closeSwitch: 'Arrêt',
    del: 'Effacer',
    selected: 'Sélectionné',
    farGoing: 'Exécution du cloud',
    nearGoing: 'Exécution sur site',
    timingDot: 'Timing',
    sensorDot: 'Capteur :',
    rhythmtime: 'Heure',
    nowarn: "Désolé, vous ne pouvez pas modifier l'état de la boucle à cette étape",
    groupControl: 'Contrôle de groupe',
    timeStarToEnd: "Période sélectionnée (l'heure de fin est supérieure ou égale à l'heure de début)",
    selectGateway: 'Sélectionnez un boîtier de connexion intelligent',
    groupControlTip: 'Une fois le contrôle de groupe sélectionné, tous les appareils et groupes actuels ne sont plus disponibles !',
    noFindGateWayTip: 'Aucune Smart Connect Box disponible',
    luxCorrectNum: 'Niveau de lux calibré :',
    constillumName: 'Nom de la lumière du jour',
    rhythmName: 'Nom du programme',
    constillumNameTips: "Veuillez définir ici un nom pour l'automatisation de la lumière du jour",
    rhythmNameTips: 'Veuillez saisir un nom de programme',
    rhythmSelectJoinModel: 'Activer',
    manualmode: 'Exécution manuelle',
    panelmode: 'Déclenchement par panneau',
    devicemode: 'Déclenchement du dispositif',
    schedulemode: 'Planification',
    nonemode: 'Invalide',
    sensorCorrectionTips: "Remarque : le capteur n'a pas été calibré. Veuillez d'abord calibrer le capteur sur la page d'installation.",
    automationTotal: 'Total des automatisations',
    iftttCustomSetPanel: 'Configuration du panneau',
    iftttSelectPanel: 'Sélectionner Smart Switch',
    iftttDefaultNoRealImg: 'Image non disponible pour le moment',
    automationRules: "Règles d'automatisation",
    configurationDetails: 'Détails de la configuration',
    maxConfigMessage: '10 points temporels maximum',
    maxConfigMessage30: '30 points temporels maximum',
    configWarnMessage: "L'intervalle entre deux points doit être supérieur à 1 heure.",
    hclConfig: 'HCL',
    lightTripConfig: 'Configuration de la bande',
    templateConfig: 'Capteur intelligent',
    hcl: 'HCL',
    areacontrol: 'Contrôle de zone',
    hclNameTips: 'Veuillez saisir un nom HCL',
    hclName: 'Nom HCL',
    hcl02: 'Définir la courbe HCL',
    hclLine: 'Affichage de la courbe HCL',
    copyIfttt: "Copier l'automatisation",
    isLoadingData: 'Chargement des données. Veuillez patienter un instant.',
    notice: 'Notifications',
    needOneClickConfiguration: 'La configuration en un clic est-elle nécessaire ?',
    oneClickConfiguration: 'Configuration en un clic',
    elfInfo: "La configuration en un clic paramètrera automatiquement l'automatisation des boutons « Marche/Arrêt », « Luminosité » et « Température de couleur/Couleur ». Les ambiances doivent être configurées sur la page de détails de l'appareil.",
    controlObject: 'Dispositifs de contrôle',
    wakePro: "Veuillez réactiver l'appareil en appuyant sur n'importe quelle touche de celui-ci, puis cliquez sur « Enregistrer ».",
    wakeProRetry: "Veuillez réactiver l'appareil en appuyant sur n'importe quelle touche de celui-ci.",
    aWakened: 'Réactiver',
    associatedConfiguration: 'Configurations de packs',
    associatedInfo: 'Veuillez ajouter les appareils',
    associatedConditioning: 'Synchronisation des climatiseurs',
    addObject: 'Ajouter des appareils',
    noConfiguration: 'Aucune configuration',
    buttonAutomation: "Configuration de l'automatisation des touches",
    createUp3: "Créer jusqu'à ${{n}} éléments",
    selectObjects: 'Sélectionner les appareils',
    intelligentControl: 'Scènes (facultatif)',
    clickExecute: 'Appuyer brièvement pour exécuter',
    lightDetection: 'Détection de la lumière',
    clickDetect: 'Cliquer pour détecter',
    switchFn1: 'Cliquer pour changer de fonction',
    switchFn2: 'Tourner pour régler la valeur',
    onOff: 'Appuyer brièvement pour allumer/éteindre la lumière',
    rotate: 'Tourner',
    constantIlluminanceTip: "Lorsque la stratégie d'éclairage constant règle la luminosité de la lampe au niveau le plus bas, éteindre les lumières",
    chooseSame: 'Veuillez sélectionner des appareils similaires',
    sureUseIfttt: "Êtes-vous sûr de vouloir activer l'automatisation ?",
    sureDisableIfttt: "Êtes-vous sûr de vouloir désactiver l'automatisation ?",
    useIftttTip: "Après avoir activé l'automatisation, la minuterie, le planning, le rythme, l'éclairage constant et l'automatisation de la zone actuelle seront activés",
    disableIftttTip: "Une fois l'automatisation désactivée, la minuterie, le programme, le rythme, l'éclairage constant et l'automatisation de la zone actuelle seront désactivés",
    needChangeGateway: `Désolé ! Ce boîtier connecté ne prend pas en charge la fonction « Activer/Désactiver » ;\n    si vous souhaitez utiliser cette fonction, veuillez opter pour un boîtier connecté compatible.`,
    needUpdateGateway: "Veuillez d'abord mettre à jour le micrologiciel, puis vous pourrez utiliser la fonction « Activer/Désactiver ».",
    sensorTemplate: 'Capteur intelligent',
    panelTemplate: 'Modèle de panneau',
    scheduledSequence: 'Séquence programmée',
    loopSequence: 'Séquence en boucle',
    actionItem: "Élément d'action",
    pleaseAddOneActionItem: "Veuillez ajouter au moins un élément d'action",
    addScheduledSequenceItem: 'Ajouter un élément de séquence programmée',
    sunriseSunset: 'Lever/Coucher du soleil',
    pleaseAddOneSequenceStep: 'Veuillez ajouter au moins une étape de séquence programmée',
    eachStepNeedsActionItem: "Chaque étape de séquence programmée nécessite au moins un élément d'action",
    absoluteTime: 'Heure absolue',
    relativeDelay: 'Délai relatif',
    effectiveCount: "Nombre d'effets",
    repeatLoop: 'Boucle de répétition',
    customLoopCount: 'Nombre de boucles personnalisé',
    times: 'fois',
    supportSunriseSunsetOffset: 'Permet de définir 0 à 240 minutes avant/après le lever/coucher du soleil',
    selectSunriseSunset: 'Sélectionner lever/coucher du soleil',
    associatedDateSettings: 'Paramètres de date associés',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    supplementalLighting: 'Éclairage d\'appoint',
    slTimeOverlapTip: 'Les plages horaires ne peuvent pas se chevaucher ; unité lumière naturelle : μmol/(m²·s)',
    slAddStrategy: '+ Nouvelle stratégie',
    slEmptyStrategy: 'Aucune stratégie. Cliquez sur « Nouvelle stratégie »',
    slStrategyName: 'Nom de la stratégie',
    slStrategyType: 'Type de stratégie',
    slLampSwitchStatus: 'État de la lampe',
    slTargetBrightnessPpfd: 'Luminosité cible | PPFD',
    slTargetLightPpfd: 'Lumière cible (PPFD)',
    slIsEnabled: 'Activé',
    slNewStrategy: 'Nouvelle stratégie',
    slEditStrategy: 'Modifier la stratégie',
    slStrategyNameLabel: 'Nom de la stratégie :',
    slStrategyCondition: 'Conditions de stratégie',
    slExecuteAction: 'Actions d\'exécution',
    slNaturalLightMin: 'Lumière naturelle min. :',
    slNaturalLightMax: 'Lumière naturelle max. :',
    slNaturalLightRangeError: 'La limite inférieure de lumière naturelle doit être inférieure à la limite supérieure',
    slDelayLightOn: 'Allumage différé',
    slDelayLightOnTip: 'Après l\'allumage, la luminosité augmente progressivement de 0 % jusqu\'à la luminosité cible. Le système effectue un réglage par étapes selon l\'intervalle d\'ajustement et le nombre total d\'ajustements jusqu\'à atteindre la valeur cible.',
    slAdjustInterval: 'Intervalle d\'ajustement :',
    slAdjustCount: 'Nombre d\'ajustements :',
    slTargetBrightness: 'Luminosité cible :',
    slTargetLight: 'Lumière cible :',
    slTimeOrderError: 'L\'heure de début et l\'heure de fin ne peuvent pas être identiques',
    slTimeOverlapError: 'Les plages horaires se chevauchent. Veuillez ajuster avant d\'enregistrer',
    slDelayAdjustDurationError: 'Intervalle × (nombre d\'ajustements - 1) ne peut pas dépasser la durée de la stratégie',
    slCrossDay: ' (jour suivant)',
    slApplying: 'Application de la stratégie…',
    slCreating: 'Création…',
    slSaving: 'Enregistrement…',
    slStrategyPrefix: 'Stratégie',
    slTypeStaticTimed: 'Statique (minutage)',
    slTypeStaticNatural: 'Statique (minutage + lumière naturelle)',
    slTypeDynamic: 'Dynamique',
    slAreaAnchor: 'Ancre de zone (μmol/m²·s)',
    slAreaAnchorTip: 'Ancre d\'intensité à pleine puissance pour convertir le % de luminosité en PPFD : PPFD = ancre × luminosité %',
    slArtificialDli: 'DLI artificiel (mol/m²·d) :',
    slNaturalDli: 'DLI naturel (mol/m²·d) :',
    slCumulativeDli: 'DLI cumulé (mol/m²·d) :',
    slTurnOffWhenMet: 'Éteindre lorsque la condition est remplie',
    slTimelineCover: 'Couverture 24H',
    slSelectAreaLeft: 'Veuillez d\'abord sélectionner une zone à gauche',
    slCompleteStrategy: 'Veuillez renseigner toutes les informations de stratégie',
    slConfirmDelete: 'Supprimer cette stratégie ?',
    slDisabled: 'Désactivé',
  },
  iftttset: {
    noSimultaneously: 'Ne peut pas être exécuté simultanément',
    rename: 'Renommer',
    isOccupied: `Les appareils suivants ont été configurés sur $$, impossible d'utiliser le contrôle de groupe`,
    or: 'ou',
    Mon: 'Lun',
    Tues: 'Mar',
    Wed: 'Mer',
    Thur: 'Jeu',
    Fri: 'Ven',
    Sat: 'Sam',
    Sun: 'Dim',
    doifttt: 'Créer un ifttt',
    doswitchifttt: 'ifttt ON/OFF',
    doscene: 'Exécuter des scènes',
    device: 'Dispositif',
    allcondition: 'Toutes les conditions',
    onecondition: 'N\'importe quelle condition',
    select: 'Sélectionner',
    allday: 'Toute la journée',
    long: 'Toujours',
    noholiday: 'Ajout aux jours fériés',
    baseinfor: 'Informations de base',
    basename: 'Nom',
    automationset: 'Paramètres d\'automatisation',
    effectivetime: 'Période effective',
    adddata: 'Ajouter',
    if: 'Si',
    selectioncriteria: 'Sélectionner',
    timing: 'Planification',
    handledo: 'Exécution manuelle',
    do: 'Faire',
    do1: 'Aller à',
    delay: 'Délai',
    minutes: 'min',
    scene: 'Scénarios',
    ifttt: 'Automatisation',
    switchifttt: 'Activer/désactiver un automatisme',
    save: 'Sauvegarder',
    back: 'Retourner à',
    week: 'Semaine',
    time: 'Heure',
    to: 'à',
    starttime: 'Heure de début',
    endtime: 'Heure de fin',
    range: 'Intervalle de temps',
    data: 'Date',
    butholiday: 'Hors jours fériés (cocher pour exclure les jours fériés)',
    sure: 'Confirmer',
    cancle: 'Annuler',
    timingset: 'Paramètres de temporisation',
    delayset: 'Délai',
    triggerset: 'Déclencheur',
    actionset: 'Configuration des actions',
    namewarning: "Veuillez créer un nom pour l'ifttt",
    effectivetimewarning: "Définir l'heure d'activation",
    conditions: 'Sélectionner la condition',
    triggerwarning: "Veuillez d'abord définir votre condition « si ».",
    actionwarning: "Veuillez définir d'abord votre condition « Do ».",
    weekwarning: 'Sélectionnez une donnée',
    handlewarning: "L'ifttt manuel ne peut pas être supprimé",
    nodoiftttwarning: "Exécution incorrecte de l'ifttt",
    onehandlewarning: 'Un seul ifttt manuel peut être ajouté',
    deldevicewarning: "Supprimez d'abord l'appareil et l'heure",
    candohandlewarning: "L'ifttt manuel ne peut pas être exécuté",
    delhandlewarning: "Veuillez d'abord supprimer l'ifttt manuel",
    tommrow: 'Jour suivant',
    upmove: 'Monter',
    downmove: 'Descendre',
    up: 'Monter',
    down: 'Descendre',
    and: 'à',
    hour: 'Heure',
    off: 'Mode OFF',
    on: 'Mode ON',
    add: 'Ajouter',
    minus: '#VALUE!',
    colormode: 'Mode Chaud',
    colorAddmode: 'Mode Chaud',
    colorMinusmode: 'Mode Froid',
    closeMode: 'Fermer tous les autres modes',
    openMode: 'Ouvrir tous les autres modes',
    key1: 'Clé 1',
    key2: 'Clé 2',
    key3: 'Clé 3',
    key4: 'Clé 4',
    key5: 'Clé 5',
    key6: 'Clé 6',
    key7: 'Clé 7',
    key8: 'Clé 8',
    keyOn: 'Clé ON',
    keyOff: 'Clé OFF',
    keyAdd: 'Clé +',
    keyMinus: 'Clé -',
    officeMode: 'Mode Réunion 1',
    speechMode1: 'Mode PPT 1',
    speechMode2: 'Mode PPT 2',
    officeTemplate: 'Modèle de bureau',
    chooseTemplate: 'Veuillez sélectionner le modèle',
    choose: 'Choisir',
    enterTemplateName: 'Veuillez saisir le nom du modèle',
    havePeople: 'Présence',
    noPeople: 'Unoccupied',
    illumination: 'Lumière du jour',
    rhythm: 'Calendrier',
    second: 'deuxième',
    officeAutomation: "Ensemble d'automatisation de bureau",
    SelectDelayTime: 'Veuillez choisir le délai',
    SelecTtriggle: 'Au moins un événement doit être défini',
    SelecAction: 'Au moins une action doit être définie',
    SelecTime: "Sélectionnez l'heure",
    haveTime: "L'heure existe déjà",
    setTiming: "Vous ne pouvez définir qu'une seule heure",
    setSun: 'Un seul lever/coucher de soleil peut être configuré',
    timeOrSunExclusive: 'La minuterie et le lever/coucher de soleil ne peuvent pas coexister',
    pleaseAddOneDelayItem: 'Veuillez ajouter au moins un élément de délai',
    lux: 'Éclairement (lux)',
    times: 'Temps (s)',
    dataStep: 'Synchronisation',
    ok: 'Confirmer',
    cancel: 'Annuler',
    info: 'Avis',
    delIllumination: 'Êtes-vous sûr de vouloir supprimer la scène « Lumière du jour » ?',
    delRhythm: 'Confirmez-vous la suppression du programme ?',
    IlluminationDevice: 'Appareils d\'éclairement',
    developAutomation: 'Ensemble d\'automatisations du département de développement',
    deviceMove: 'Détecteur de mouvement',
    deviceMove1: 'Détecteur de mouvement',
    alreadydelete: 'Il a déjà été supprimé',
    alreadymove: 'Il a déjà été déplacé',
    repeat: 'Répétition',
    every: 'Tous les jours',
    wordDay: 'Jour ouvrable',
    weekEnd: 'Week-ends',
    customize: 'Sur mesure',
    weekTip: 'Veuillez sélectionner la période de répétition',
    timeTip: "Veuillez sélectionner l'heure de début et de fin",
    dataTip: 'Veuillez sélectionner la date de début et de fin',
    along: 'En cours',
    triggershowtotaltip: 'Veuillez ne pas ajouter plus de #16# conditions « Si »',
    actionshowtotaltip: 'Veuillez ne pas ajouter plus de #32# conditions « Faire »',
    triggerandactiontip: 'Veuillez ne pas ajouter plus de #16# conditions « Si » et #32# conditions « Faire ».',
    areacontrol: 'Contrôle de zone',
    SelecArea: 'Au moins une zone doit être définie',
    hcl: 'HCL',
    templateList: "Liste des modèles d'automatisation",
    holidays: 'Vacances',
    notHolidays: 'Pas de vacances',
    executeOnlyOnce: 'A faire une seule fois',
    executionMode: "Mode d'exécution",
    moreSettings: 'Plus de paramètres',
    local: 'Local',
    cloud: 'Cloud',
    recommendation: 'Recommander',
    tip1: "L'exécution locale est disponible même en mode hors ligne",
    tip2: "Si l'exécution locale n'est pas possible, essayez de passer à l'exécution dans le cloud",
    ifttt3Tip: 'Les appareils suivants ne prennent pas en charge la fonctionnalité #holiday#. Veuillez effectuer les ajustements nécessaires',
    ifttt3Tip2: 'Les appareils suivants prendront en charge la fonctionnalité #holiday# après la mise à jour.',
    delayedToggleAutomationSwitchState: "Retarder le changement d'état de l'automatisation",
    automaticalTurnOnOff: '#2 secondes# plus tard, #éteindre# automatiquement',
    automationSettings: "Paramètres d'automatisation",
    toggleSettings: 'Paramètres de basculement marche/arrêt',
    notConfigured: "Les paramètres de jours fériés ne sont pas configurés. Veuillez vous rendre dans les détails du projet pour configurer d'abord les jours fériés",
    permissionDenied: "Il a été détecté que vous ne disposez pas des autorisations requises pour cette action. Veuillez contacter le chef de projet/l'installateur pour demander l'accès.",
    areaName: 'Nom de la pièce',
    gotoConfig: 'Aller à la configuration',
    sunrise: 'Lever du soleil',
    sunset: 'Coucher du soleil',
    dateRange: 'Plage de dates',
    timingSequenceAction: 'Action de séquence temporelle',
    timeSetting: 'Paramètres de temporisation',
    pleaseInputConstantLightIntensityName: 'Veuillez entrer le nom de la luminosité constante',
    noSupportTip: 'Version du micro-logiciel du concentrateur ou du dispositif trop faible, veuillez d\'abord mettre à jour',
  },
  lastLight: {
    Illuminance: 'Illuminance',
    open: 'boucle ouverte',
    close: 'boucle fermée',
    lessthan: 'moins',
    brightness: 'luminosité',
    range: 'Plage',
    to: 'à',
    big: 'plus',
    standard: 'Tableau de référence des normes d\'éclairement des locaux',
    warning: "Avertissement : veuillez patienter jusqu'à ce que la lecture du capteur soit stable",
    selectwaring: 'Sélectionnez au moins un appareil',
    must: 'Sélectionnez au moins un appareil',
    selectwaring2: "Sélectionnez l'appareil",
    selectwaring3: 'Veuillez indiquer le niveau de lux',
    selectwaring4: 'Plage incorrecte',
    selectwaring5: 'Plage incorrecte',
    selectwaring6: 'Plage incorrecte'
  },
  otatask: {
    firmware: 'Micrologiciel',
    mainFirmware: 'Firmware principal',
    childFirmware: 'Firmware enfant',
    latest: 'Dernière version',
    upgrading: 'Mise à niveau en cours.',
    taskCreateAllName: 'Mise à jour de tous les appareils',
    areaname: 'Zone',
    canUpgradeingDevice: 'Appareils pouvant être mis à jour',
    canUpgradeingDevice2: 'Appareils pouvant créer une tâche de mise à niveau',
    initiatefail: 'Échec du lancement de la mise à jour',
    warninginfor: 'Aucun appareil pouvant être mis à niveau',
    waitForupgrade: 'En attente',
    UpgradeChecking: 'Vérification en cours',
    Upgradeing: 'Mise à jour en cours',
    UpgradeSuccess: 'Mise à niveau réussie',
    taskSuccess: 'Réussi',
    UpgradePartSuccess: 'Réussite partielle',
    UpgradeDuplicate: 'Dupliqué',
    UpgradeFail: 'Échec de la mise à niveau.',
    taskFail: 'Échoué',
    UpgradeConfilct: 'Conflit d\'opération',
    UpgradeBusy: 'Occupé',
    UpgradeProjectIdNull: 'Aucun ID de projet',
    UpgradePasue: 'Pause',
    info: 'Info',
    stopfail: 'Échec de l\'arrêt',
    stopsuccess: 'Arrêt réussi',
    createTime: "Définir l'heure",
    startTime: 'Heure de début',
    lastTime: 'Dernière fois',
    userId: 'Utilisateur',
    bysku: 'Par type',
    byarea: 'Par zone',
    devicetype: "Type d'appareil",
    selectedsku: 'Référence sélectionnée',
    selecteddevice: 'Appareil sélectionné',
    resumeOperate: 'Annuler',
    taskname: 'Nom de la tâche',
    taskjuststart: 'Exécution immédiate',
    taskCustom: 'Exécution planifiée',
    createUpgradeTask: 'Créer une tâche de mise à niveau',
    createUpgradeTaskTimeTip: 'Cette tâche de mise à niveau prendra environ # minutes. Les résultats peuvent être consultés dans la liste des tâches de mise à niveau',
    taskNameTip: 'Veuillez saisir le nom de la tâche',
    finishcontinuecreate: 'Créer une autre tâche',
    taskDeleteTip: 'Êtes-vous sûr de vouloir supprimer la tâche n° # ?',
    Unicast: "Mise à niveau d'un seul appareil",
    byprojectUpgradeStart: 'Tout mettre à niveau',
    selected: 'Sélectionné',
    tasktitlesku: 'Type :',
    tasktitledevice: 'Dispositif',
    UpgradeStop: 'Terminer la mise à niveau',
    taskStop: 'Arrêter',
    nostopupdatetip: "L'équipement sélectionné pour la mise à niveau contient des appareils qui ne peuvent pas être arrêtés dès le début de la mise à niveau. Une fois la tâche de mise à niveau annulée, ces appareils continueront à effectuer la mise à niveau !",
    oparenosametip: "Le statut de la tâche actuellement sélectionnée est incohérent, impossible d'unifier l'opération par lots",
    taskStoppingTip: 'Arrêter',
    taskid: 'ID de la tâche'
  },
  qrcode: {
    projectsettitle: 'Emplacement du projet non déterminé !',
    projectsettip: "La création d'un code QR nécessite un emplacement précis du projet pour définir les autorisations de zone",
    projectsetok: 'Configurer',
    projectsetcancel: 'Non défini',
    switchtitle: "Êtes-vous sûr de vouloir désactiver l'accès via le code QR ?",
    switchtip: "Une fois l'accès au code QR désactivé, les utilisateurs qui partagent via ce code QR ne pourront plus accéder à cette zone du projet, et les utilisateurs qui y accèdent actuellement seront également contraints de quitter la zone !",
    deltitle: 'Êtes-vous sûr de vouloir supprimer le code QR ?',
    deltip: "Une fois le code QR supprimé, les droits d'accès à la zone seront désactivés, les utilisateurs qui y accèdent actuellement seront contraints de quitter la zone, et toutes les informations associées seront supprimées !",
    qrcodetitle: 'Limite de zone',
    switch: 'Activer le partage',
    sharearea: 'Zone de partage',
    qrcodename: 'Nom du code QR',
    qrcodenametip: 'Le nom ne peut pas être vide',
    screenroatetip: 'Pour une meilleure expérience, veuillez placer votre téléphone ou votre tablette en position verticale',
    intoloading: 'Chargement du centre de contrôle du code QR',
    device: 'Dispositif',
    areacontrol: 'Contrôle de zone',
    scene: 'Scénarios',
    positionsearchtip: 'Veuillez saisir une adresse',
    position: 'Localisation',
    latlon: 'Longitude',
    latitude: 'Latitude',
    longitude: 'Longitude',
    ableActionTip: "L'auteur du partage a désactivé l'accès. Si vous avez des questions, veuillez contacter l'administrateur !",
    ableTokenTip: "L'autorisation n'est pas valide. Si vous rencontrez un problème, veuillez contacter l'administrateur !",
    gpsOpen: 'La localisation est activée',
    gpsOpenTip: `Pour obtenir vos données de localisation, veuillez activer la localisation et autoriser le navigateur à y accéder<br><br>\n        Essayez ce qui suit :<br>\n        1. Veuillez activer le service de localisation mobile et autoriser le navigateur à accéder à vos données de localisation<br>\n        2. Dans les paramètres de localisation du navigateur, tous les sites web sont autorisés à accéder à vos données de localisation`,
    locationserices: 'Services de localisation',
    whileappuse: "Pendant l'utilisation de l'application",
    beyondPositionTip: `<h>Votre position actuelle est trop éloignée pour accéder !</h><br><b>Veuillez essayer les actions suivantes à proximité de la zone de scan :</b><br>1. Activez le service de localisation et autorisez le navigateur à y accéder<br>2. Dans les paramètres de localisation du navigateur, autorisez tous les sites à accéder à la position`,
    changearea: 'Zone de commutation',
    mapnoadresstip: 'Adresse associée introuvable !',
    createqrcode: 'Générer le code QR',
    createqrcodetips: "Vous êtes sur le point de créer un code QR permettant de contrôler l'installation d'éclairage intelligent via un smartphone. Veuillez noter que, pour des raisons de sécurité, il n'est possible de contrôler l'éclairage via ce code QR que si l'utilisateur se trouve à moins de 2 km du site du projet. L'utilisateur doit donc activer sa localisation GPS et autoriser la page web à l'utiliser afin de vérifier qu'il se trouve bien sur le site du projet.",
    isWXAppTips: "Veuillez l'ouvrir dans le navigateur par défaut",
    pulldownrefresh: 'Tirer vers le bas pour actualiser',
    releaseupdate: 'Relâchez pour actualiser',
    updating: 'Mise à jour',
    loading: 'chargement…',
    startingGPSpositioning: 'Lancement du positionnement GPS...',
    GPSPositioningInProgress: 'Positionnement GPS en cours...',
    accuracy: 'Précision',
    altitude: 'Altitude',
    altitudeAccuracy: "Précision de l'altitude",
    heading: 'Cap',
    groundSpeed: 'Vitesse au sol',
    GPSPositioningFailed: 'Échec du positionnement GPS',
    startingBDPositioning: 'Lancement du positionnement BD...',
    BDPositioningInProgress: 'Positionnement BD en cours...',
    BDPositioningDataReturned: 'Données de positionnement BD renvoyées...',
    BDPpositioning: 'Positionnement BD',
    BDPositioningFailed: 'Échec du positionnement BD',
    BDPositioningStartupFailed: 'Échec du démarrage du positionnement BD'
  },
  home: {
    changeProfessional: 'Passage à la version professionnelle réussi',
    changeNotProfessional: 'Passage à la version normale réussi',
    zoomScaleTip: "Le navigateur est en mode zoom, la mise en page peut ne pas s'adapter à la page. Un agrandissement à 100 % est recommandé.",
    onlineTipsHeaderTitle: 'Hors ligne ?',
    onlineTipsDescribe: 'Veuillez vérifier votre connexion Internet. Les paramètres seront enregistrés dans le cloud. Une connexion Internet instable peut entraîner une perte de données.',
    onlineTipsOKtext: "D'accord, j'ai compris",
    allArea: 'Toutes les zones',
    allProject: 'Tous les projets',
    ruiyi: 'Éclairage intelligent',
    ouxiangjia: 'OPPLE Home',
    collectTop: 'Meilleurs articles de la collection',
    collectOnly: 'Afficher uniquement mes favoris'
  },
  base: {
    notice: 'Avis',
    sure: 'Confirmer',
    back: 'Retourner à',
    cancel: 'Annuler',
    deltext: 'Êtes-vous sûr de vouloir supprimer ?',
    more: "Plus d'informations",
    delete: 'Effacer',
    transfer: 'Transférer',
    move: 'Déménagement',
    download: 'Télécharger',
    export: 'Exporter',
    import: 'Importer',
    type: 'Type :',
    state: "Statut de l'appareil",
    all: 'Tout',
    total: 'Quantité',
    upStep: 'Retour',
    nextStep: 'Suivant',
    name: 'Nom',
    selectall: 'Sélectionner tout',
    latestedVersion: 'Dernière version',
    localVersion: 'Version locale',
    restart: 'Réessayer',
    start: 'Démarrer',
    pasue: 'Pause',
    refresh: 'Rafraîchir',
    create: 'Créer',
    searchKey: 'Mot-clé de recherche',
    searchByState: 'Recherche par État',
    searchByCreateTime: 'Recherche par date de création',
    operate: 'Opération',
    resetFilter: 'Réinitialiser le filtre',
    to: 'à',
    startdate: 'Date de début',
    enddate: 'Données de fin',
    lastWeek: 'Semaine dernière',
    lastMonth: 'Mois dernier',
    lastThreeMonths: 'Trois derniers mois',
    details: 'Détails',
    startingTip: "Commencer l'opération",
    restartingTip: "Redémarrer l'opération",
    errorcode: "Code d'erreur",
    search: 'Recherche sur',
    succeed: 'Réussi',
    error: 'Échoué',
    group: 'Groupe',
    applyFor: 'Postuler',
    noEmpty: 'ne peut pas être vide',
    bind: 'Lier',
    unbind: 'Délier',
    redraw: 'Redessiner le point',
    mobilephonenumber: 'Téléphone portable',
    smsverificatoncode: 'Code de vérification',
    sendverificatoncode: 'Envoyer',
    sendagain: 'Renvoyer',
    write: 'Écrire',
    finish: 'Effectué',
    spread: 'déplier',
    modify: 'Éditer',
    notip: 'Aucun conseil',
    detail: 'Détails',
    save: 'Sauvegarder',
    yes: 'Oui',
    no: 'Non',
    skip: 'Sauter',
    updateTitle: 'Note de mise à jour',
    helpCenter: "Centre d'aide",
    before: 'Avant',
    after: 'Après',
  },
  visual: {
    pdfTransFail: 'Échec de la conversion du fichier PDF.',
    sizeMaxFile: `Les dimensions du fichier ne doivent pas dépasser $$1px*$$2px`,
    maxFile: `La taille du fichier ne doit pas dépasser $$mb`,
    lightRate: "Taux d'éclairage",
    areaRank: 'Classement régional',
    areaChoose: 'Sélectionnez une zone',
    searchDevicePlaceholder: "Veuillez saisir un nom d'appareil pour la recherche",
    deviceDetail: "Détails de l'appareil",
    childDeviceRelation: 'Topologie des appareils',
    drawRoom: 'Salle de dessin',
    drawArea: 'Zone de dessin',
    pic: 'Photos',
    maxNumPic: "Téléchargez jusqu'à 10 images",
    maxSizePic: "La taille de l'image ne peut pas dépasser 10000*10000px.",
    deviceNeedTime: "L'appareil n'est pas encore entièrement chargé",
    lowEnergy: 'Faible consommation',
    highEnergy: 'Haute consommation',
    upImgAndLook: "Il n'y a aucun schéma dans cette zone. Veuillez suivre les étapes ci-dessous pour ajouter des schémas et les configurations associées avant de les consulter.",
    initConfigTip1: "Il n'y a actuellement aucun dessin pour cette zone. Veuillez d'abord ajouter des dessins en suivant les étapes ci-dessous.",
    initConfigTip2: `1. Prend en charge les formats d'image .jpg, .jpeg et .png dont la taille ne dépasse pas $$1 Mo et est inférieure à $$2 px * $$3 px.`,
    initConfigTip3: `2. Prend en charge le format .pdf sans limite de taille.`,
    regionFrom: 'Zone',
    isSetNetwork: 'Réseau configuré ?',
    moreTitle: "Plus d'informations sur l'état et le fonctionnement de l'équipement",
    deviceMore: 'Cliquez pour afficher',
    bindagin: 'Rétablir',
    bindingDiologTxt: 'Supprimer uniquement le cadre de la zone :',
    bindingDiologTxt1: 'Supprime uniquement le cadre de la zone, les icônes des appareils restent.',
    bindingDiologTxt2: 'Tout supprimer :',
    bindingDiologTxt3: 'Supprime la zone et les icônes des appareils.',
    bindingDiologBtnTxt: 'Supprimer uniquement le cadre de la zone',
    bindingDiologBtnTxt1: 'Tout supprimer',
    rightBind: 'Cliquez avec le bouton droit pour délimiter la pièce',
    monitorUploadImg: "Il n'y a aucun dessin dans cette zone.",
    toUpload: 'Aller au téléchargement',
    currentArea: 'Zone actuelle',
    enableIfttt: 'Activer',
    disableIfttt: 'Désactiver',
    enableIftttDialogTitle: "Les types d'automatisation suivants seront activés, les autres automatisations ne sont pas affectées !",
    disableIftttDialogTitle: "Les types d'automatisation suivants seront désactivés, les autres automatisations ne sont pas affectées !",
    useDeviceDailog: 'Utiliser la liste des appareils pour sélectionner',
    chooseDeviceInMap: "Utiliser la sélection du plan d'étage",
    cancleAllSelect: 'Tout annuler',
    selectSameDevice: "Sélectionner le même type d'appareils",
    chooseSKU: 'Sélectionner le type de produit',
    deleteConfirmTxt: "Après la suppression d'une zone, les emplacements d'origine des appareils dans la zone seront automatiquement supprimés du plan d'étage.",
    rebindConfirmTxt: "Après avoir réattribué une zone, les emplacements d'origine des appareils dans cette zone seront automatiquement supprimés du plan d'étage.",
    deviceTypes: "Veuillez sélectionner le type de protocole de l'appareil",
    deleteEquipmentTip1: "Supprimer uniquement la zone : supprime uniquement la zone et conserve l'icône de l'appareil <br /> Tout supprimer : supprime la zone et l'icône de l'appareil à l'intérieur de la zone",
    deleteEquipmentTip2: 'Supprimer uniquement le cadre de zone',
    deleteEquipmentTip3: 'Tout supprimer',
    please: 'Veuillez',
    deviceRepeat: "L'appareil existe déjà",
    deviceInSelectRoom: 'Le ou les appareils doivent être placés dans la pièce sélectionnée',
    device: 'Dispositif',
    selectRoom: 'Veuillez sélectionner la zone : ##',
    deviceListMsg: "Une fois la zone sélectionnée associée, l'appareil peut être déplacé vers cette zone.",
    batchMobile: 'Déplacer plusieurs appareils',
    delAreaMsg: 'Vous devez supprimer tous les appareils de la zone sélectionnée avant de la réassocier. Êtes-vous sûr de vouloir supprimer les appareils ?',
    modify: 'Modifier',
    mapBg: 'Arrière-plan de la carte',
    roomTips: 'Étiquette de pièce',
    deviceTips: "Étiquette d'appareil",
    replace: "Remplacer le plan d'étage",
    del: 'Effacer',
    identification: 'Identifier',
    bindArea: 'Zone délimitée',
    placeBind: "Veuillez d'abord associer la zone à une pièce",
    closeLight: 'désactivez',
    uploadImg: "Télécharger une image",
    imgSize: "Taille de l'image",
    lessThen: 'et inférieure à',
    uploading: "Téléchargement de l'image en cours, veuillez patienter",
    complete: 'Effectué',
    bindAreaSet: 'Paramètres de la zone délimitée',
    areaPlan: 'Plan de la zone',
    areaIsBound: "La pièce est déjà associée à d'autres zones sélectionnées, veuillez la désassocier avant de continuer!",
    areaDoNotBind: 'La zone ne peut pas être associée',
    clickInCanvas: "Veuillez essayer d'appuyer sur cet appareil et de le faire glisser vers le plan d'étage",
    imgType: 'Formats pris en charge : jpg, jpeg, png. La taille maximale est de 5 Mo',
    noImgType: "Ce type de fichier n'est pas pris en charge",
    noImgSize: 'Fichier trop volumineux',
    planarModel: "Aller au plan d'étage",
    edtAreaMsg: 'Il y a encore des appareils dans la zone. Veuillez les supprimer avant de modifier',
    mapIsLoading: 'chargement…',
    selectDevice: 'Choisir un appareil',
    scence: 'Scénarios',
    ifttt: 'Automatisation',
    ok: 'Confirmer',
    cancel: 'Annuler',
    addScene: 'Ajouter',
    chooseDeviceGroup: 'Sélectionner un groupe d\'appareils',
    uifiedControl: 'Tout contrôler',
    width: 'Largeur',
    height: 'Hauteur',
    editBg: 'Taille du panneau',
    notice: 'Avis',
    sureDelScene: 'Êtes-vous sûr de vouloir supprimer?',
    sureDelGroup: 'Êtes-vous sûr de vouloir supprimer?',
    delBg: "Supprimer l'arrière-plan",
    noName: 'Luminaires OPPLE',
    virtualDevice: 'Appareils virtuels',
    virtualLibrary: 'Liste des appareils',
    areaname: 'Zone',
    realDevice: 'Appareils configurés en réseau',
    floorname: 'Etage',
    virtualPoint: 'Zone virtuelle',
    rect: 'Zone rectangulaire',
    pencil: 'Dessiner une zone',
    opacity: 'Transparence',
    bgColor: 'Noir/blanc',
    virtualTips: 'Glisser-déposer un appareil dans la zone',
    searchKey: 'Veuillez entrer le nom de votre appareil',
    select: 'Sélectionner',
    zoomScale: 'Échelle de zoom',
    Legend: 'Filtre',
    connectDevice: 'Appareils connectés',
    backDevice: 'Liste des appareils existants',
    hasMac: 'Appareils virtuels avec adresse MAC',
    lightBox: 'Éléments standard - boîte à lumière',
    batchBind: 'Liaison par lots',
    batchNetwork: 'Réseau par lots',
    oneKeyConfig: 'Distribution en un clic',
    other: 'Autres',
    downloadPoint: 'Télécharger la liste des points',
    createStandardProject: 'Créer un programme standard',
    noNetwork: 'Réseau non distribué',
    toUpgrade: 'Aller à la mise à niveau',
    upgradeTip: 'Si les versions des appareils suivants ne répondent pas aux exigences, mettez-les à niveau avant de tenter de les livrer.',
    upgradeTip2: "S'il n'y a pas de problème, cliquez sur « Remplacer l'appareil », saisissez à nouveau l'adresse MAC et relancez la livraison !",
    changeDevice: "Remplacer l'appareil",
    sendScene: 'Envoi du scénario',
    sendingScene: 'La scène est en cours de distribution',
    sendSceneSuccess: 'La scène est distribuée',
    sendSceneFail: 'Échec de la section de la scène',
    sendIfttt: 'Distribution automatisée',
    sendingIfttt: 'La distribution automatisée est en cours',
    sendIftttSuccess: 'Automatisation émise',
    sendIftttFail: 'Échec de la partie automatisation',
    sendProgram: 'Émission du livret de programmes',
    sendingProgram: 'Les programmes sont en cours de distribution',
    sendProgramSuccess: 'La liste des programmes a été émise',
    sendProgramFail: 'Échec de la section de la liste des programmes',
    noBind: 'Sans reliure',
    macError: "L'adresse MAC est incorrecte",
    uploadPoint: 'Télécharger le tableau des points',
    pointName: 'Nom du point',
    remark: 'Remarque',
    next: 'Suivant',
    networked: 'réticulé',
    addressNotFilled: 'Adresse non renseignée',
    addressRepeat: 'Adresse en double, veuillez la saisir à nouveau',
    waitNetwork: "Veuillez patienter pendant que l'appareil se connecte au réseau, environ 1 à 3 minutes...",
    continueNetwork: 'Réseau de distribution en cours',
    waitNetwork2: "En attente que l'appareil se connecte au réseau",
    gatewayNetwork: 'La passerelle Optical Box est en cours de distribution',
    deviceRepeatBind: "L'appareil ne peut pas être lié à plusieurs reprises",
    networkFail: 'Échec de la configuration réseau, réessayez plus tard',
    gateway: 'Passerelle Optical Box',
    networking: 'Configuration du réseau',
    networkFail2: "Échec de la configuration réseau, changez l'adresse MAC et continuez",
    networkFail3: "La version de la passerelle doit être mise à jour, veuillez d'abord la mettre à jour, puis configurer le réseau",
    networkFail4: "Veuillez cliquer sur le bouton « Opération » de l'appareil pour lancer le compte à rebours",
    networkFail5: "Passerelle ajoutée avec succès, redémarrage logiciel d'environ 28 secondes, veuillez patienter...",
    networkFail6: "S'il n'y a pas de problème, veuillez remplacer l'appareil, saisir à nouveau l'adresse MAC, puis cliquer sur « Continuer la configuration réseau »",
    refreshDevice: 'Actualiser la liste des appareils',
    pointNameTip: 'Spécifier le nom du point',
    networkState: 'Mode de jumelage',
    bindDeviceTip: "{BindDeviceCount} appareils ont été liés, {NotBindPointCount} points n'ont pas été liés et il y a {NotBindDeviceCount} appareils non liés, veuillez lier les points et appareils correspondants",
    networkFailTip: 'Échec de la configuration réseau, réessayez plus tard',
    goToMonitor: 'Aller à Moniteur',
    goToInstallation: 'Aller à Installation',
    themeChange: 'Changement de thème',
    exit: 'Se déconnecter',
    duplicateMAC: 'Il y a des appareils en double au même point',
    removeDevice: "Veuillez ne pas retirer l'appareil de la pièce.",
    moveIntoTheRoom: 'Déplacer dans la pièce',
    topLeft: 'En haut à gauche',
    topRight: 'En haut à droite',
    Center: 'Au centre',
    bottomLeft: 'En bas à gauche',
    bottomRight: 'En bas à droite',
    deviceClustering: 'Regroupement de périphériques'
  },
  sortSelect: {
    type1: 'Ordre par nom A-Z',
    type2: 'Ordre par nom Z-A',
    type3: 'Ordre ascendant par temps ajouté',
    type4: 'Ordre décroissant par temps ajouté'
  },
  hcl: {
    deviceHcl: 'Rythme du périphérique',
    chartAllData: 'Afficher les données',
    saveTemplate: 'Ajouter aux modèles personnalisés',
    oppleTemplate: 'Modèles OPPLE HCL',
    template: 'Modèles personnalisés',
    choose: 'Sélection',
    hclType: 'Sélectionner le type HCL',
    argumentType: 'Sélectionner le type de paramètre',
    gradient: 'Mode fluide',
    jump: 'Mode par paliers',
    lightCCT: 'Luminosité + CCT',
    onlyLight: 'Luminosité',
    onlyCCT: 'CCT',
    whichHcl: "L'appareil a été ajouté à {a}",
    CantHcl: "L'appareil ne prend pas en charge la fonction HCL",
    warning: 'Remarque : la zone actuelle contient des appareils qui ne prennent pas en charge la fonction HCL ; la fonction de contrôle de zone ne peut donc pas être utilisée',
    warning1: "Veuillez d'abord mettre à jour les appareils",
    enable: 'Activer',
    unable: 'Désactiver',
    state: "Statut de l'appareil",
    time: 'Heure',
    number: 'N°',
    enabled: 'Activé avec succès',
    unabled: 'Désactivé',
    perform: 'Exécution sur site',
    useTemplate: 'Appliquer',
    office: 'Bureau',
    school: 'École',
    factory: 'Industrie',
    naturalLight: 'Lumière du soleil',
    keywords: 'Saisir les mots-clés de recherche',
    addTime: "Ajouter l'heure",
    allHcl: 'Luminosité + CCT',
    lightHcl: 'Luminosité',
    CCTHcl: 'CCT',
    hclState: 'État HCL',
    tips: 'Avis',
    warning2: "1、Lorsque vous faites glisser pour modifier la température de couleur, le réglage de la température de couleur de l'automatisation HCL à laquelle appartient l'appareil sera interrompu, et le réglage de la luminosité se poursuivra. <br />2、Lorsque vous faites glisser pour modifier la luminosité, le réglage de la luminosité de l'automatisation HCL à laquelle appartient l'appareil sera interrompu, et le réglage de la température de couleur se poursuivra. <br />3、Lorsque la luminosité et la température de couleur ont toutes deux été modifiées, l'automatisation HCL à laquelle appartiennent les appareils sera désactivée.<br/>4、 Si une zone HCL a été créée, l'automatisation ne peut pas être interrompue.",
    HclConfig: 'Paramètres HCL',
    warning3: "Ajouter un point : double-cliquez n'importe où sur la courbe HCL.",
    warning4: 'Modifier un point : faites glisser et déposez le point.',
    warning5: 'Supprimer un point : cliquez sur le point et sélectionnez « Supprimer ».',
    warning6: 'Avertissement : la distance entre deux points doit être supérieure à 1 heure.',
    close: 'désactivez',
    search: 'Recherche sur',
    introduce: 'Présentation',
    type: 'Type :',
    del: 'Effacer',
    all: 'Sélectionner tout',
    cancle: 'Annuler',
    add: 'Ajouter',
    set: 'Détails du nœud',
    colorName: 'CCT',
    cardLightCCT: 'Luminosité HCL + CCT',
    cardLight: "Luminosité en cours d'exécution",
    cardCCT: "En cours d'exécution uniquement CCT",
    cardStop: 'HCL désactivé',
    editPoint: 'Modifier un point',
    modify: 'Éditer',
    clear: 'Effacer',
    warning7: "Il est recommandé d'utiliser les paramètres de contrôle par zone pour plus de 20 appareils.",
    warning8: 'Veuillez saisir le nom du modèle.'
  },
  identify: {
    identify_default: "Utilisez « identifier » pour localiser l'appareil"
  },
  reset: {
    reset_00010900_step_1: `1. Mettre sous tension la passerelle
2. Brancher le câble Ethernet : il doit permettre l'accès à Internet et obtenir une adresse IP via DHCP
3. Si nécessaire, connecter les appareils DALI via DA+/DA- ; aucune alimentation bus DALI supplémentaire n'est requise`,
    reset_00010900_step_1_title: 'Installation de la passerelle filaire',
    reset_00010900_step_1_check: 'Sous tension et connectée au réseau',
    reset_00010900_step_2: `1. Maintenez le bouton « Opération » à l'avant de la passerelle enfoncé plus de 10 secondes
2. Comme illustré, le voyant d'état vert clignote rapidement ; la passerelle redémarre`,
    reset_00010900_step_2_title: "Réinitialiser l'appareil",
    reset_00010900_step_2_check: 'La passerelle a été réinitialisée',
    reset_00010900_step_3: `1. Si le voyant Ethernet est éteint, vérifiez la connexion du câble au routeur ou si une IP statique est requise. En cas d'IP statique, suivez les instructions pour terminer la configuration
2. Si le voyant cloud est éteint, vérifiez que le routeur a accès à Internet
3. Si le voyant d'état est orange, il s'agit d'un défaut logiciel ; revenez à l'étape précédente et réessayez. Si le problème persiste, contactez le fournisseur de la passerelle
4. Si le voyant d'état est rouge, il s'agit d'un défaut matériel ; contactez le fournisseur de la passerelle`,
    reset_00010900_step_3_title: "Vérifier l'état de la passerelle",
    reset_00010900_step_3_check: 'Tous les voyants sont allumés et verts',
    reset_00010900_step_4: `Saisissez l'adresse MAC indiquée sur la passerelle, ou scannez le code QR sur l'appareil pour générer automatiquement l'adresse MAC`,
    reset_00010900_step_4_title: "Remplir l'adresse MAC",
    reset_00010900_step_5: `Appuyez sur le bouton « Confirmer » de l'appareil, puis cliquez sur « Suivant » dans les 120 secondes suivant la confirmation`,
    reset_00010900_step_5_title: 'Confirmer la passerelle',
    reset_00010900_step_5_check: 'Appareil identifié et confirmé'
  },
  energyBoard: {
    noMeasuringDevice: "Il n'y a pas de dispositif de comptage pour cet élément. Veuillez ajouter le dispositif de comptage, puis saisir cet élément de configuration.",
    energyFixedConfig: "Configuration du quota de consommation d'énergie",
    carbonEmission: "Configuration du facteur d'émission de carbone",
    carbonFactor: "Facteur d'émission de carbone",
    country: 'Pays',
    inputByCountry: "Le pays actuel n'a pas configuré le facteur d'émission de carbone. Veuillez le saisir manuellement.",
    inputCarbonFactor: 'Saisie manuelle',
    inputManualSelection: 'Sélection manuelle',
    inputNumber: 'Veuillez saisir un nombre',
    configTips: "Veuillez vous assurer que tous les appareils de la zone sélectionnée sont connectés à l'outil de comptage associé à cette zone.",
    energyAndcarbonEmissionsConfig: "Configuration du quota de consommation d'énergie/des émissions de carbone",
    measureDevice: 'Comptage',
    deviceArea: "Zone de l'appareil",
    deviceStatistics: "Zone statistique de l'appareil",
    timeClickTip: "Cliquez sur la date pour sélectionner l'heure de début, puis cliquez à nouveau pour sélectionner l'heure de fin",
    HVAC: 'HVAC',
    powerConsumption: 'Consommation d\'énergie',
    otherConsumption: 'Autre consommation',
    showByDay: 'Quotidienne',
    showByWeek: 'Hebdomadaire',
    showByMonth: 'Mensuelle',
    showByQuarter: 'Trimestrielle',
    showByYear: 'Annuelle',
    countrySet: 'Pays du projet',
    carbonEmissionSet: "Attribuer un facteur d'émission de carbone",
    YOYcurentMonth: 'Mois dernier',
    energyType: 'Types de comparaison',
    addareaname: 'Ajouter zone',
    editareaname: 'Zone de commutation',
    energyCompare: 'Comparaison énergétique',
    energyProportion: "Proportion d'énergie",
    energyTime: 'Chronologie',
    season: 'Trimestre',
    energyConfig: 'Configuration des paramètres',
    energyConfigTips: 'Les statistiques prennent effet dès que les paramètres actuels sont configurés',
    statistiMonthly: 'Mensuel',
    statistiQuarterly: 'Trimestriel',
    statistiYear: 'Annuel',
    configTime: 'Date de configuration',
    configFinish: 'Configuration terminée',
    carbonEmissions: 'Émissions de carbone',
    lightEnergy: 'Éclairage',
    maxEnergy: 'Consommation max.',
    minEnergy: 'Consommation min.',
    averageEnergy: 'Moyenne',
    maxEnergySavingRate: 'Maximale',
    minEnergySavingRate: 'Minimale',
    averageEnergySavingRate: "Taux d'économie",
    maxCarbonEmissions: 'Maximale',
    minCarbonEmissions: 'Minimale',
    averageCarbonEmissions: 'Moyenne',
    energy: "Consommation d'énergie",
    energyDesign: 'Consommation prévue',
    energyDesign1: 'Total prévu',
    energySave: 'Économies réalisées',
    energySaveToytal: 'Total des économies',
    actualEnergy: 'Réel',
    energyBalanceCounting: "Bilan de consommation d'énergie inversé",
    unit: 'Unité',
    energyUnit: "Unités de consommation d'énergie",
    carbonEmissionsUnit: "Unités d'émissions de carbone",
    currentMonth: 'Ce mois-ci',
    currentYear: 'Cette année',
    currentSeason: 'Ce trimestre',
    energyRate: "Pourcentage d'énergie",
    energyComparison: 'Comparaison énergétique',
    remainingEnergy: "Bilan de consommation d'énergie",
    energySavingRate: 'Taux d\'économie d\'énergie',
    remainingCarbonEmissions: 'Bilan carbone',
    carbonFootprint: 'Empreinte carbone',
    sequentialData: 'Comparaison mensuelle',
    year_to_yearData: 'Données en glissement annuel',
    graph: 'Graphiques',
    table: 'Tableaux',
    exportTable: 'Exporter les rapports',
    regionTips: "Comparaison de jusqu'à 3 zones",
    region: 'Sélectionner les zones',
    statistiObject: 'Objets statistiques',
    statisticalIndex: 'Données statistiques',
    energyStatistics: "Rapport d'énergie",
    quota: 'Montant fixe',
    statistiArea: 'Zone statistique',
    energyQuota: "Quota de consommation d'énergie",
    carbonEmissionsQuota: "Quota d'émissions",
    carbonEmissionsAll: 'Émissions de carbone cumulées',
    energyAll: 'Consommation totale',
    carbonBalanceCounting: 'Compte à rebours du bilan des émissions de carbone',
    actualCarbonEmissions: 'Émissions de carbone réelles',
    year_to_year: "D'une année sur l'autre",
    curentDay: 'Jour',
    curentWeek: 'Semaine',
    curentMonth: 'Ce mois-ci',
    curentYear: 'Cette année',
    curentSeason: 'Saison',
    YOYcurentDay: 'Dernier jour',
    YOYcurentYear: "L'année dernière",
    YOYcurentSeason: 'Dernier trimestre',
    staticSum: 'Aperçu statistique',
    areaComparation: 'Comparaison historique',
    areaProportion: 'Comparaison par zone',
    max: 'Plus élevé',
    min: 'Plus bas',
    onlineTotal: 'En ligne / Total',
    openTotal: 'Éclairage allumé / Total',
    existSensor: 'Capteur de présence et de lux',
    config: 'Réglage',
    statistiObjectConfig: 'Configuration des compteurs',
    other: 'Autres',
    pieEnergyListHeader: "Classement de la consommation d'énergie réelle par comparaison de zones",
    pieEnergyListDes: "Le diagramme à barres montre le classement de la consommation d'énergie réelle de la zone sélectionnée sur la période choisie.",
    pieEnergyHeader: "Consommation d'énergie réelle par zone",
    pieEnergyDes: "Le graphique circulaire présente la consommation d'énergie réelle de la zone sélectionnée sur la période choisie.",
    statisticsNodule: 'Module statistique',
    selectStatisticalArea: 'Veuillez sélectionner une zone statistique',
    selectStatisticalModule: 'Veuillez sélectionner le module statistique',
    exportFailed: "Échec de l'exportation",
    sensorData: 'Données des capteurs',
    prohibitCrossAreaSelection: 'La sélection inter-régions est interdite',
    exportConfigTip1: "La vue d'ensemble des équipements et les statistiques de pannes ne peuvent exporter que des données en temps réel",
    exportConfigTip2: "Les données relatives aux capteurs et à l'utilisation de l'espace ne peuvent être extraites que pour l'année la plus récente",
    exportConfigTip3: "(Nombre total d'équipements, nombre d'équipements en ligne, hors ligne, en panne et données de classification)",
    exportConfigTip4: '(Mouvement, température, humidité, luminosité)',
    exportConfigTip5: "(Statistiques d'indices, ratios régionaux d'une année sur l'autre/d'un mois sur l'autre, proportions régionales)",
    exportConfigTip6: "La statistique relative à la part de la consommation d'énergie correspond par défaut à la part de toutes les régions subordonnées.",
    selectDateRangeTip: 'La plage de dates sélectionnée ne peut pas dépasser 5 ans',
    selectDateRangeTip1: 'La plage de dates sélectionnée ne peut pas dépasser 90 jours',
    selectDateRangeTip2: 'La plage de dates sélectionnée ne peut pas dépasser 12 mois',
    problemFeedback: 'Signaler un problème',
    questionDescribe: 'Description du problème',
    describeTip1: 'Veuillez décrire en détail le problème rencontré ou fournir vos conseils',
    describeTip2: "Veuillez saisir la référence de l'appareil (8 caractères hexadécimaux), vous pouvez la trouver dans les informations sur l'appareil",
    describeTip3: 'Numéro de téléphone ou e-mail',
    describeTip4: 'Veuillez saisir un numéro de téléphone ou une adresse e-mail valide',
    describeTip5: 'Veuillez remplir toutes les informations',
    describeTip6: 'Téléchargez un fichier compressé valide',
    describeTip7: "Veuillez saisir l'adresse MAC des appareils",
    describeTip8: 'Veuillez saisir votre nom',
    deviceInfo: 'Informations appareil',
    startTime: 'Heure de début et de fin du problème',
    userInfo: 'Informations de compte',
    userName: 'Nom',
    userPhone: 'Coordonnées',
    sureSubmit: 'Soumettre',
    firstEnergy: 'Économies liées à la rénovation',
    secondEnergy: 'Économies intelligentes',
    secondEnergyRate: "Taux d'économies intelligentes",
    firstEnergyRate: "Taux d'économies liées à la rénovation",
    firstEnergyV2: 'Économies liées à la rénovation (taux)',
    secondEnergyV2: 'Économies intelligentes (taux)',
    energyMode: "Mode de consommation d'énergie (statistiques)",
    designEnergyConsumption: "Consommation d'énergie prévue",
    rulesDes: 'Explication des règles',
    rulesOpenDes: 'Heures de travail : Énergie totale prévue = Puissance nominale des luminaires * Nombre de luminaires * Heures de travail. Heures hors travail : Énergie totale prévue = Puissance nominale des luminaires * Nombre de luminaires allumés * Heures hors travail.',
    rulesCloseDes: "Énergie totale prévue pour les jours ouvrés = Puissance nominale des luminaires * Nombre de luminaires allumés * Heures d'allumage des luminaires",
    rulesOpenDes1: 'Énergie totale prévue = Énergie prévue pour les heures de travail + Énergie prévue pour les heures hors travail',
    rulesOpenDes2: 'Énergie prévue pour les heures de travail = Puissance nominale des luminaires * Nombre de luminaires * Heures de travail.',
    rulesOpenDes3: 'Énergie prévue pendant les heures non ouvrables = Puissance nominale des luminaires * Nombre de luminaires allumés * Heures non ouvrables.',
    open: 'Démarrer',
    closed: 'désactivez',
    infoFrom: "Les informations proviennent de « Projet » - « Informations sur le pays » - « Pays d'affiliation »",
    infoFrom1: 'Les informations proviennent de:',
    infoFrom2: 'Projet - Informations sur le pays - Pays',
    city: 'Ville',
    building: 'Bâtiment',
    floor: 'Etage',
    room: 'Salle',
    selectAreaType: '${{n}} groupes sélectionnés',
    tip1: 'Explication des données',
    tip2: "Consommation d'énergie prévue = Consommation d'énergie réelle + Économie d'énergie ;",
    tip3: "Économie d'énergie = Économie d'énergie liée à la rénovation + Économie d'énergie intelligente ;",
    tip4: "Taux d'économie d'énergie moyen = Économie d'énergie / Consommation d'énergie prévue ;",
    tip5: "Taux d'économies intelligentes = (Consommation d'énergie prévue après rénovation - Consommation d'énergie réelle) / Consommation d'énergie prévue après rénovation",
    tip6: "Taux d'économies liées à la rénovation = (Énergie avant rénovation - Énergie prévue après rénovation) / Énergie avant rénovation",
    noPermissionContactOwner: 'Vous ne disposez actuellement pas des autorisations nécessaires pour modifier les paramètres. Veuillez contacter le créateur du projet pour activer cette fonction.'
  },
  recycle: {
    dataRecovery: 'Récupération des données',
    sceneAutomationDeleteTips: 'Les scènes et automatisations affichent les jours restants avant suppression, puis sont supprimées définitivement',
    restore: 'Restaurer',
    deviceCannotBeEmpty: "L'appareil ne peut pas être vide ; cet enregistrement ne peut pas être restauré",
    relatedDeviceDeleted: "L'appareil associé a été supprimé ; restauration impossible",
    triggerActionCannotBeEmpty: "L'action de déclenchement ne peut pas être vide ; cet enregistrement ne peut pas être restauré",
    executionActionCannotBeEmpty: "L'action d'exécution ne peut pas être vide ; cet enregistrement ne peut pas être restauré",
    day: 'Jour(s)'
  },
  notices: {
    noticeTimes: 'Définir la fréquence des notifications',
    timeInterval: 'Intervalle de temps',
    timeCount1: '15 minutes',
    timeCount2: '30 minutes',
    timeCount3: '1 heure',
    timeCount4: '12 heures',
    timeCount5: '24 heures',
    timeInterval_title1: 'Notification immédiate',
    timeInterval_title2: 'Notification toutes les heures par appareil',
    timeInterval_title3: 'Notification à une heure précise',
    timeInterval_title4: 'Désactiver les notifications',
    timeInterval_description1: "Déclencher une notification lorsque l'appareil change d'état.",
    timeInterval_description2: "Quel que soit le nombre de fois où l'appareil remplit les conditions de déclenchement, chaque appareil ne recevra qu'une seule notification par heure.",
    timeInterval_description3: "Dans l'intervalle défini, quelle que soit le nombre d'appareils remplissant les conditions, une seule notification sera envoyée.",
    timeInterval_description4: 'Aucune notification une fois la condition de déclenchement remplie',
    subscription_name: "Nom de l'abonnement",
    subscription_type: "Type d'abonnement",
    sensor_alarm: 'Alertes de capteur',
    addSpecifiedDevice: 'Ajouter un appareil spécifique',
    triggerConditions: 'Conditions de déclenchement',
    meetAllSensors: 'Tous les capteurs',
    satisfyAnySensor: "N'importe quel capteur",
    alarmConfiguration: "Configuration de l'alarme",
    notificationObject: 'Objets de notification',
    auth: 'Autorisation',
    notifSelf: "M'avertir par défaut",
    specifyUser: 'Utilisateur désigné',
    pushUser: 'Utilisateurs push',
    method: 'Méthode de notification',
    subscriptionCenter: "Centre d'abonnement",
    allSubscriptions: 'Tous les abonnements',
    addSubscription: 'Ajouter un abonnement',
    all: 'Tout',
    noticeList: "Si vous souhaitez modifier ou annuler cette notification, veuillez contacter l'un des comptes suivants.",
    know: 'confirmé',
    checkDelete: 'Confirmer la suppression ? Cette action est irréversible !',
    deleteSuccess: 'Supprimé avec succès.',
    watchAll: 'Afficher tous les messages',
    messageCenter: 'Centre de messages',
    sendDate: "Date d'envoi",
    ownProject: 'Projet concerné',
    messageDetails: 'Détails du message',
    processedMan: 'Processeur',
    isHandle: 'Traité ou non',
    processed: 'Traité',
    notProcessed: 'Non traité',
    clickHandler: 'Cliquez pour traiter',
    checkHandler: 'Confirmez-vous que le message a été traité ? Cette action ne peut pas être annulée !',
    readAll: 'Marquer tout comme lu',
    processedSuccess: 'Traitement réussi',
    selectDate: 'Sélectionner la date',
    markAsProcessed: 'Marquer comme traité',
    readed: 'Lu',
    unRead: 'Non lu',
    project: 'Projet',
    systemNotifications: 'Notification du système',
    emailNotifications: 'Notification par e-mail',
    messageNotifications: 'Notification par SMS',
    appPush: "Notification via l'application",
    sensor: 'Capteur',
    processingTime: 'Temps de traitement',
    envAlarm: 'Catégorie environnementale',
    areaAlarm: 'Catégorie régionale',
    envAlarmTip: "(Utilisez les données transmises par le capteur comme condition de déclenchement pour envoyer des alarmes ou des notifications lorsque l'environnement change et répond aux conditions définies.)",
    areaAlarmTip: '(Envoyez les données du système relatives à la zone désignée à intervalles réguliers)',
    noticeByDay: 'Envoi quotidien',
    noticeByWeek: 'Envoi hebdomadaire',
    noticeByMonth: 'Envoi mensuel',
    pushTime: "Heure d'envoi",
    noticeByDayDescription: '(Une fois par jour, envoyez les données de la veille.)',
    noticeByWeekDescription: "(Heure d'envoi quotidienne pour envoyer les données de la semaine dernière)",
    noticeByMonthDescription: "(Heure d'envoi quotidienne pour envoyer les données du mois dernier)",
    eachMonday: 'Tous les lundis',
    eachTuesday: 'Tous les mardis',
    eachWednesday: 'Tous les mercredis',
    eachThursday: 'Tous les jeudis',
    eachFriday: 'Tous les vendredis',
    eachSaturday: 'Tous les samedis',
    eachSunday: 'Tous les dimanches',
    pushContent: "Contenu de l'envoi",
    temperature: 'température et humidité',
    faultProportion: 'pourcentage de pannes',
    thirdPartyAccount: 'Comptes personnels tiers',
    thirdPartyGroupAccount: 'Comptes de groupe tiers',
    batchImport: 'Importation par lots',
    downloadImportTemplate: "Télécharger le modèle d'importation",
    oppleUser: 'Abonnés OPPLE',
    thirdParty: 'Utilisateurs tiers',
    personalAccount: 'compte personnel',
    groupAccount: 'compte de groupe',
    oppleUserAccount: 'Abonnés OPPLE',
    thirdPartyPersonalAccount: 'Utilisateurs individuels tiers',
    thirdPartyGroup: 'Groupe tiers',
    deviceTotal: "Nombre total d'appareils, données en ligne et hors ligne",
    energyStatistics: "Consommation d'énergie réelle, économies d'énergie, taux d'économie d'énergie",
    areaTemperature: "Données régionales sur la température et l'humidité",
    areaFaultProportion: "Données sur le pourcentage d'équipements défectueux dans la région (identiques à celles de l'application - Détails des équipements défectueux)",
    addAccount: 'Ajouter un compte',
    batchDelete: 'Suppression groupée',
    importTemplate: "Modèles d'importation",
    areaCodeError: 'GpNo en double',
    messagePush: 'Notification push',
    pushMethod: 'Mode de notification',
    pushApp: "Notification push vers l'application mobile",
    timeStamp: 'Horodatages',
    Day: 'Jour'
  },
  icp: {
    company: '© Suzhou Opple Lighting Co., Ltd.',
    icpNo: "Numéro d'enregistrement ICP du Jiangsu : 13004515",
    networkSecurity: 'Numéro de réserve de sécurité du réseau public de Suzhou n° 32050902100527'
  },
  networkCheck: {
    networkCheck: 'Détection de réseau',
    selectArea: 'Veuillez sélectionner la zone',
    cloudServer: 'Serveurs cloud',
    normalSubDevice: 'Normal',
    abnormalSubDevice: 'Défaut',
    offlineSubDevices: 'Hors ligne',
    weakSignal: 'Signal de communication faible',
    linkNotWorking: 'Échec de la communication réseau',
    signalDifferenceEquipment: 'Appareils avec un signal de communication faible',
    offlineDevice: 'Appareils hors ligne',
    unableGateway: 'Impossible de terminer la liaison avec la passerelle',
    reset: "Réinitialisation aux paramètres d'usine",
    others: 'Appareils en communication directe',
    affectedIfttt: 'Automatisation affectée',
    affectedIftttTip: "Les Smart Connect Box du système d'automatisation sont situées sur différents réseaux locaux ou segments de réseau, ce qui entraîne une déconnexion du réseau et des problèmes de communication.",
    serverCloud: 'Serveurs cloud',
    signalStrength: 'Puissance du signal',
    communicationRate: 'Taux de réussite des communications',
    noGateway: "Aucune Smart Connect Box — impossible de continuer à évaluer l'état du réseau.",
    notCompatible: 'Échec de la connexion au serveur cloud',
    test: 'Évaluer',
    communicationTimes: "L'état de la communication",
    concatIt: 'Veuillez contacter le service informatique',
    deviceList: 'Liste des appareils',
    completed: 'Tout est terminé',
    DetectionTool: 'Outils',
    correspondingGateway: 'Smart Connect Box correspondante',
    networkSegment: 'Segment réseau',
    waitingToStart: 'En attente de démarrage',
    onlyWin: 'Pris en charge uniquement sous Windows',
    toolsTip: `Utilisez l'outil ci-dessous pour vérifier si le réseau local autorise l'accès aux domaines et ports requis par OPPLE Cloud`,
    smallTool: 'Outil auxiliaire',
    localAreaNetwork: 'Vous pouvez contacter le service informatique pour ajuster le réseau et vous assurer que la Smart Connect Box correspondante se trouve sur le même réseau local.',
    status1: 'En attente',
    status2: 'Détection en cours',
    status3: 'Détection terminée',
    abnormalCause: "Cause de l'anomalie",
    solution: 'Solution',
    normalCommunication: `Ajustez la configuration réseau pour que les passerelles du système d'automatisation soient sur le même LAN et rétablissez une communication normale.`,
    judgmentCriteria: "Critères d'évaluation",
    poorCommunication: "Signal faible de l'appareil actuel, taux de réussite de communication inférieur à $$%",
    indicatorDiagram: 'Schéma des voyants',
    threeIndicators: 'Les trois voyants suivants : (1) voyant système, (2) voyant LAN, (3) voyant connexion cloud',
    troubleshootingSteps: 'Étapes de dépannage',
    step1_v1: `1. Si les trois voyants sont éteints, l'alimentation ou le système peut être en panne ; vérifiez l'alimentation ou remplacez le matériel`,
    step2_v1: `2. Si le voyant LAN (2) est allumé et le voyant cloud (3) clignote, l'accès Internet est normal mais la connexion à OPPLE Cloud est anormale ; vérifiez les restrictions de domaines et de ports locaux`,
    domainLabel: 'Nom de domaine :',
    portLabel: 'Port :',
    step3_v1: `3. Si le voyant LAN (2) est allumé et le voyant cloud (3) est éteint, la Smart Connect Box ne peut pas accéder à Internet ; vérifiez les restrictions du réseau local`,
    step4_v1: `4. Si le voyant LAN (2) est éteint, la Smart Connect Box n'obtient pas d'IP ; vérifiez le câble réseau, les restrictions DHCP et la configuration IP statique`,
    fourIndicators: "Les quatre voyants suivants : (1) voyant d'alimentation, (2) voyant système, (3) voyant LAN, (4) voyant connexion cloud",
    step1_v2: "1. Si le voyant d'alimentation (1) est éteint, l'alimentation peut être anormale ; vérifiez l'alimentation",
    step2_v2: `2. Si les voyants système (2), LAN (3) et cloud (4) sont tous éteints, il peut s'agir d'une panne système ; remplacez le matériel`,
    step3_v2: `3. Si le voyant LAN (3) est allumé et le voyant cloud (4) clignote, l'accès Internet est normal mais OPPLE Cloud est anormale ; vérifiez les restrictions de domaines et de ports`,
    officialDomain: 'Nom de domaine cloud officiel (selon le projet ; Europe : iotctrl1) : ',
    step4_v2: `4. Si le voyant LAN (3) est allumé et le voyant cloud (4) est éteint, la Smart Connect Box ne peut pas accéder à Internet ; vérifiez les restrictions du réseau local`,
    step5_v2: `5. Si le voyant LAN (3) est éteint, la Smart Connect Box n'obtient pas d'IP ; vérifiez le câble, le DHCP et la configuration IP statique`,
    fourIndicators_v3: 'Quatre voyants : (1) voyant système, (2) voyant LAN, (3) voyant connexion cloud, (4) voyant Wi-Fi',
    step1_v3: `1. Si les quatre voyants sont éteints, l'alimentation ou le système peut être en panne ; vérifiez l'alimentation ou remplacez le matériel`,
    wifiStatusDesc: '5. Description du voyant Wi-Fi (4) :',
    wifiOff: 'Voyant éteint : fonction Wi-Fi non activée.',
    wifiRedFlash: 'Rouge clignotant : Wi-Fi activé mais SSID non configuré.',
    wifiRedOn: "Rouge fixe : connexion au point d'accès (AP) en cours.",
    wifiGreenFlash: "Vert clignotant : connecté au point d'accès mais sans adresse IP.",
    wifiGreenOn: "Vert fixe : connecté au point d'accès avec une adresse IP valide ; réseau normal.",
    issueType: 'Type de problème',
    correspondingGateway2: 'Smart Connect Box correspondante',
    crossNetwork: 'Segment réseau croisé',
    crossGateway: 'Smart Connect Box croisée'
  },
  controlArea: {
    bindRoomError1: 'Le bouton et certaines luminaires ({names}) ne sont pas sur la même passerelle. La variation est temporairement indisponible. Veuillez les déplacer sur la même passerelle.',
    bindRoomError2: 'Le bouton et tous les luminaires de cette pièce ne sont pas sur la même passerelle et ne peuvent pas être contrôlés. Veuillez les connecter à la même passerelle.',
    bindRoomError3: 'Il n\'y a aucun luminaire contrôlable dans cette pièce. Veuillez déplacer le bouton dans une pièce avec des luminaires ou resélectionner.',
    reSelect: 'Resélectionner',
    knew: 'Compris',
  },
  ...Locale,
}
export default fr
